
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.0";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.0";

});



parcelRegister("gxbk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c09882a49af06a79$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $c09882a49af06a79$var$UserContext = /*#__PURE__*/ (0, $acw62.createContext)({
    loggedInUser: 'Neha'
});
var $c09882a49af06a79$export$2e2bcd8739ae039 = $c09882a49af06a79$var$UserContext;

});

parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("a9zaE", function(module, exports) {
module.exports = import("jmW5S").then(()=>parcelRequire('h0EEC'));

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $ayMG0 = parcelRequire("ayMG0");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$var$decodePath(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $gxbk0 = parcelRequire("gxbk0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;



var $acw62 = parcelRequire("acw62");
const $caae5368ead5995e$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $acw62.useState)(()=>{
        if (typeof window === "undefined") return true;
        return window.navigator.onLine;
    });
    (0, $acw62.useEffect)(()=>{
        const handleOnlineStatus = ()=>setOnlineStatus(true);
        const handleOfflineStatus = ()=>setOnlineStatus(false);
        window.addEventListener("online", handleOnlineStatus);
        window.addEventListener("offline", handleOfflineStatus);
        return ()=>{
            window.removeEventListener("online", handleOnlineStatus);
            window.removeEventListener("offline", handleOfflineStatus);
        };
    }, []);
    return onlineStatus;
};
var $caae5368ead5995e$export$2e2bcd8739ae039 = $caae5368ead5995e$var$useOnlineStatus;


const $3df07944bfa6aab3$var$Header = ()=>{
    const { loggedInUser: loggedInUser } = (0, $acw62.useContext)((0, $gxbk0.default));
    const onlineStatus = (0, $caae5368ead5995e$export$2e2bcd8739ae039)();
    // Subscribing to the store using Selector
    const cartItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.cart.items);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "logo",
                    src: "https://img.freepik.com/premium-vector/online-food-app-icon-food-shop-location-logo-also-online-resturent-location-template_608547-155.jpg"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "navBar",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: " Home "
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/about",
                                    children: " About Us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/cart",
                                    children: [
                                        " Cart(",
                                        cartItems.length,
                                        ") "
                                    ]
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: onlineStatus ? "network-badge online" : "network-badge offline",
                            children: onlineStatus ? "Online" : "Offline"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: loggedInUser
                        })
                    ]
                })
            })
        ]
    });
};
var $3df07944bfa6aab3$export$2e2bcd8739ae039 = $3df07944bfa6aab3$var$Header;



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $cd74848ad11950cb$var$RestaurantCard = (props)=>{
    // this is called destructuring
    const { resName: resName, cuisines: cuisines, time: time, rating: rating, image: image } = props;
    const formattedCuisineText = cuisines.length > 20 ? cuisines.slice(0, 20) + "..." : cuisines;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "res-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "res-logo",
                alt: "res-img",
                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" + image
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "resName",
                children: [
                    " ",
                    resName.length > 25 ? resName.slice(0, 25) + "..." : resName
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "ratingTime",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            " ",
                            rating,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            " ",
                            time + ' - ' + (time + 10) + " mins",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "res-cuisine",
                children: [
                    " ",
                    formattedCuisineText,
                    " "
                ]
            })
        ]
    });
};
var $cd74848ad11950cb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($cd74848ad11950cb$var$RestaurantCard);



var $acw62 = parcelRequire("acw62");



// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$O = Object;
var $5f9e38360d79f95a$var$getPrototypeOf = $5f9e38360d79f95a$var$O.getPrototypeOf;
var $5f9e38360d79f95a$var$CONSTRUCTOR = "constructor";
var $5f9e38360d79f95a$var$PROTOTYPE = "prototype";
var $5f9e38360d79f95a$var$CONFIGURABLE = "configurable";
var $5f9e38360d79f95a$var$ENUMERABLE = "enumerable";
var $5f9e38360d79f95a$var$WRITABLE = "writable";
var $5f9e38360d79f95a$var$VALUE = "value";
var $5f9e38360d79f95a$export$541ac630993a4c84 = (value)=>!!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || $5f9e38360d79f95a$var$isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value[$5f9e38360d79f95a$var$CONSTRUCTOR]) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE][$5f9e38360d79f95a$var$CONSTRUCTOR].toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || !$5f9e38360d79f95a$var$isObjectish(value)) return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null || proto === $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE]) return true;
    const Ctor = $5f9e38360d79f95a$var$O.hasOwnProperty.call(proto, $5f9e38360d79f95a$var$CONSTRUCTOR) && proto[$5f9e38360d79f95a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$5f9e38360d79f95a$var$isFunction(Ctor)) return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $5f9e38360d79f95a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : $5f9e38360d79f95a$var$isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $5f9e38360d79f95a$var$has = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $5f9e38360d79f95a$var$get = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $5f9e38360d79f95a$var$set = (thing, propOrOldValue, value, type = $5f9e38360d79f95a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $5f9e38360d79f95a$var$isArray = Array.isArray;
var $5f9e38360d79f95a$var$isMap = (target)=>target instanceof Map;
var $5f9e38360d79f95a$var$isSet = (target)=>target instanceof Set;
var $5f9e38360d79f95a$var$isObjectish = (target)=>typeof target === "object";
var $5f9e38360d79f95a$var$isFunction = (target)=>typeof target === "function";
var $5f9e38360d79f95a$var$isBoolean = (target)=>typeof target === "boolean";
function $5f9e38360d79f95a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $5f9e38360d79f95a$var$getProxyDraft = (value)=>{
    if (!$5f9e38360d79f95a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$5f9e38360d79f95a$var$DRAFT_STATE];
};
var $5f9e38360d79f95a$var$latest = (state)=>state.copy_ || state.base_;
var $5f9e38360d79f95a$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $5f9e38360d79f95a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if ($5f9e38360d79f95a$var$isArray(base)) return Array[$5f9e38360d79f95a$var$PROTOTYPE].slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $5f9e38360d79f95a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$5f9e38360d79f95a$var$WRITABLE] === false) {
                desc[$5f9e38360d79f95a$var$WRITABLE] = true;
                desc[$5f9e38360d79f95a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$5f9e38360d79f95a$var$CONFIGURABLE]: true,
                [$5f9e38360d79f95a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
                [$5f9e38360d79f95a$var$VALUE]: base[key]
            };
        }
        return $5f9e38360d79f95a$var$O.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = $5f9e38360d79f95a$var$O.create(proto);
        return $5f9e38360d79f95a$var$O.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) $5f9e38360d79f95a$var$O.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    $5f9e38360d79f95a$var$O.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>{
        $5f9e38360d79f95a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    [$5f9e38360d79f95a$var$VALUE]: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || !$5f9e38360d79f95a$var$isObjectish(obj)) return true;
    return $5f9e38360d79f95a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$PluginMapSet = "MapSet";
var $5f9e38360d79f95a$var$PluginPatches = "Patches";
var $5f9e38360d79f95a$var$PluginArrayMethods = "ArrayMethods";
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
var $5f9e38360d79f95a$var$isPluginLoaded = (pluginKey)=>!!$5f9e38360d79f95a$var$plugins[pluginKey];
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$getCurrentScope = ()=>$5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginMapSet) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginArrayMethods) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginArrayMethods) : void 0
    });
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
var $5f9e38360d79f95a$var$enterScope = (immer2)=>$5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) result = $5f9e38360d79f95a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft);
    $5f9e38360d79f95a$var$maybeFreeze(scope, result, true);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $5f9e38360d79f95a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
function $5f9e38360d79f95a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $5f9e38360d79f95a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT = [];
function $5f9e38360d79f95a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $5f9e38360d79f95a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $5f9e38360d79f95a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $5f9e38360d79f95a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $5f9e38360d79f95a$var$each(parentCopy, (key, value)=>{
            if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$5f9e38360d79f95a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
        $5f9e38360d79f95a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $5f9e38360d79f95a$var$markStateFinalized(state);
    }
}
function $5f9e38360d79f95a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
        const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
        if ($5f9e38360d79f95a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $5f9e38360d79f95a$var$prepareCopy(target);
            const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
            $5f9e38360d79f95a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $5f9e38360d79f95a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $5f9e38360d79f95a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($5f9e38360d79f95a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $5f9e38360d79f95a$var$handleValue($5f9e38360d79f95a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $5f9e38360d79f95a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(target) || handledSet.has(target) || !$5f9e38360d79f95a$export$16e3aed3edb85946(target) || $5f9e38360d79f95a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $5f9e38360d79f95a$var$each(target, (key, value)=>{
        if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
            const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
            if ($5f9e38360d79f95a$var$isSameScope(state, rootScope)) {
                const updatedValue = $5f9e38360d79f95a$var$getFinalValue(state);
                $5f9e38360d79f95a$var$set(target, key, updatedValue, target.type_);
                $5f9e38360d79f95a$var$markStateFinalized(state);
            }
        } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) $5f9e38360d79f95a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const baseIsArray = $5f9e38360d79f95a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop, state.type_)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $5f9e38360d79f95a$var$isArrayIndex(prop)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop, state.type_))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $5f9e38360d79f95a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $5f9e38360d79f95a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$5f9e38360d79f95a$var$WRITABLE]: true,
            [$5f9e38360d79f95a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
            [$5f9e38360d79f95a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
for(let key in $5f9e38360d79f95a$var$objectTraps){
    let fn = $5f9e38360d79f95a$var$objectTraps[key];
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? $5f9e38360d79f95a$var$VALUE in desc ? desc[$5f9e38360d79f95a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($5f9e38360d79f95a$var$isFunction(base) && !$5f9e38360d79f95a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$5f9e38360d79f95a$var$isFunction(recipe)) $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && !$5f9e38360d79f95a$var$isFunction(patchListener)) $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || !$5f9e38360d79f95a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($5f9e38360d79f95a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft($5f9e38360d79f95a$var$get(parentCopy, state.key_));
            const valueAtKey = $5f9e38360d79f95a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $5f9e38360d79f95a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $5f9e38360d79f95a$var$get(current2, key);
            if (!$5f9e38360d79f95a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$5f9e38360d79f95a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key, type_);
            const value = $5f9e38360d79f95a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $5f9e38360d79f95a$var$CONSTRUCTOR)) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if ($5f9e38360d79f95a$var$isFunction(base) && p === $5f9e38360d79f95a$var$PROTOTYPE) $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (!$5f9e38360d79f95a$var$isObjectish(base)) $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if ($5f9e38360d79f95a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $5f9e38360d79f95a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
                $5f9e38360d79f95a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($5f9e38360d79f95a$var$getValue(value));
            });
        }
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $5f9e38360d79f95a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        const result = operation();
        $5f9e38360d79f95a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c05b21e3257751e5 = (value)=>value;
var $5f9e38360d79f95a$export$20f911b3f8cf0b74 = (value)=>value;


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $87607fab672c6ed3$var$restaurantListData = [
    {
        "info": {
            "id": "657322",
            "name": "Chinese Wok",
            "cloudinaryImageId": "e0839ff574213e6f35b3899ebf1fc597",
            "locality": "Dussehra Ground",
            "areaName": "PM Mall",
            "costForTwo": "\u20B9250 for two",
            "cuisines": [
                "Chinese",
                "Asian",
                "Tibetan",
                "Desserts"
            ],
            "avgRating": 4.2,
            "parentId": "61955",
            "avgRatingString": "4.2",
            "totalRatingsString": "1.5K+",
            "sla": {
                "deliveryTime": 29,
                "lastMileTravel": 4.5,
                "serviceability": "SERVICEABLE",
                "slaString": "25-30 mins",
                "lastMileTravelString": "4.5 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-31 01:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "Rxawards/_CATEGORY-Chinese.png",
                        "description": "Delivery!"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Rxawards/_CATEGORY-Chinese.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "ITEMS",
                "subHeader": "AT \u20B9119"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "--"
                }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/chinese-wok-dussehra-ground-pm-mall-rest657322",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "65081",
            "name": "Theobroma",
            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2026/1/6/4438b1d2-3a7e-43dc-837f-18fc4d00d530_65081.JPG",
            "locality": "Sector 15",
            "areaName": "Sector 15",
            "costForTwo": "\u20B9400 for two",
            "cuisines": [
                "Bakery",
                "Desserts"
            ],
            "avgRating": 4.6,
            "parentId": "1040",
            "avgRatingString": "4.6",
            "totalRatingsString": "7.9K+",
            "sla": {
                "deliveryTime": 24,
                "lastMileTravel": 4.2,
                "serviceability": "SERVICEABLE",
                "slaString": "20-25 mins",
                "lastMileTravelString": "4.2 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-30 23:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "Rxawards/_CATEGORY-Desserts.png",
                        "description": "Delivery!"
                    },
                    {
                        "imageId": "newg.png",
                        "description": "Gourmet"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Rxawards/_CATEGORY-Desserts.png"
                                }
                            },
                            {
                                "attributes": {
                                    "description": "Gourmet",
                                    "imageId": "newg.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "50% OFF",
                "discountTag": "FLAT DEAL"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "4.1",
                    "ratingCount": "473"
                },
                "source": "GOOGLE",
                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/theobroma-sector-15-rest65081",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "637287",
            "name": "The Belgian Waffle Co.",
            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/16/8fa53ae0-16d6-4185-9380-b982f505a1d0_637287.jpg",
            "locality": "Shopping Centre Market",
            "areaName": "Sector 15",
            "costForTwo": "\u20B9200 for two",
            "cuisines": [
                "Waffle",
                "Desserts",
                "Ice Cream",
                "Beverages"
            ],
            "avgRating": 4.4,
            "veg": true,
            "parentId": "2233",
            "avgRatingString": "4.4",
            "totalRatingsString": "1.7K+",
            "sla": {
                "deliveryTime": 31,
                "lastMileTravel": 4.3,
                "serviceability": "SERVICEABLE",
                "slaString": "30-40 mins",
                "lastMileTravelString": "4.3 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-31 02:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "v1695133679/badges/Pure_Veg111.png",
                        "description": "pureveg"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "pureveg",
                                    "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "20% OFF",
                "subHeader": "UPTO \u20B950"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "--"
                }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/the-belgian-waffle-co-shopping-centre-market-sector-15-rest637287",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "780926",
            "name": "Subway",
            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/12/f704c306-98e9-4b9c-a0d6-39a019a147fe_780926.jpg",
            "locality": "Mehta Road",
            "areaName": "Pacific Mall of Faridabad",
            "costForTwo": "\u20B9350 for two",
            "cuisines": [
                "sandwich",
                "Salads",
                "wrap",
                "Healthy Food"
            ],
            "avgRating": 4.2,
            "parentId": "2",
            "avgRatingString": "4.2",
            "totalRatingsString": "780",
            "sla": {
                "deliveryTime": 30,
                "lastMileTravel": 4.3,
                "serviceability": "SERVICEABLE",
                "slaString": "25-30 mins",
                "lastMileTravelString": "4.3 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-30 23:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "ITEMS",
                "subHeader": "AT \u20B969"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "--"
                }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/subway-mehta-road-pacific-mall-of-faridabad-rest780926",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "56999",
            "name": "La Pino'z Pizza",
            "cloudinaryImageId": "mzb8tq7ccskyvadm9mt2",
            "locality": "Sector 15",
            "areaName": "Sector 15",
            "costForTwo": "\u20B9250 for two",
            "cuisines": [
                "Pizzas",
                "Pastas",
                "Italian",
                "Desserts",
                "Beverages"
            ],
            "avgRating": 4.2,
            "parentId": "4961",
            "avgRatingString": "4.2",
            "totalRatingsString": "19K+",
            "sla": {
                "deliveryTime": 27,
                "lastMileTravel": 4.6,
                "serviceability": "SERVICEABLE",
                "slaString": "25-30 mins",
                "lastMileTravelString": "4.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-31 02:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "ITEMS",
                "subHeader": "AT \u20B978"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "3.9",
                    "ratingCount": "722"
                },
                "source": "GOOGLE",
                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/la-pinoz-pizza-sector-15-rest56999",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "170934",
            "name": "Wow! Momo",
            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/30/438fb10c-ecd8-4272-b4ca-0ad5050f4674_170934.jpg",
            "locality": "Sector 15",
            "areaName": "Sector 15",
            "costForTwo": "\u20B9300 for two",
            "cuisines": [
                "Momos",
                "Chinese",
                "fastfood",
                "Asian",
                "Beverages"
            ],
            "avgRating": 4.1,
            "parentId": "1776",
            "avgRatingString": "4.1",
            "totalRatingsString": "2.7K+",
            "sla": {
                "deliveryTime": 24,
                "lastMileTravel": 4.3,
                "serviceability": "SERVICEABLE",
                "slaString": "20-25 mins",
                "lastMileTravelString": "4.3 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-31 03:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "Rxawards/_CATEGORY-Chinese.png",
                        "description": "Delivery!"
                    },
                    {
                        "imageId": "Ratnesh_Badges/Rx_Awards_2025/Momo.png",
                        "description": "Delivery!"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Rxawards/_CATEGORY-Chinese.png"
                                }
                            },
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Ratnesh_Badges/Rx_Awards_2025/Momo.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "ITEMS",
                "subHeader": "AT \u20B969"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "4.7",
                    "ratingCount": "160"
                },
                "source": "GOOGLE",
                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/wow-momo-sector-15-rest170934",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "327587",
            "name": "Delights by INOX",
            "cloudinaryImageId": "b857fcf611707fedd3773eb02688f925",
            "locality": "Ef3 Mall",
            "areaName": "Sector 20",
            "costForTwo": "\u20B9400 for two",
            "cuisines": [
                "Snacks"
            ],
            "avgRating": 3.7,
            "parentId": "385095",
            "avgRatingString": "3.7",
            "totalRatingsString": "28",
            "sla": {
                "deliveryTime": 23,
                "lastMileTravel": 0.2,
                "serviceability": "SERVICEABLE",
                "slaString": "20-25 mins",
                "lastMileTravelString": "0.2 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-30 23:57:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "60% OFF",
                "subHeader": "UPTO \u20B9120"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "--"
                }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/delights-by-inox-ef3-mall-sector-20-rest327587",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "792013",
            "name": "Karigari - By Chef Harpal Singh Sokhi",
            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/24/7a1fba10-29d0-4740-9d43-c9e027037c5d_792013.jpg",
            "locality": "Bata Chowk Metro Station",
            "areaName": "Sector 16_FBD",
            "costForTwo": "\u20B9800 for two",
            "cuisines": [
                "North Indian",
                "kebabs",
                "Biryani",
                "Mughlai"
            ],
            "avgRating": 4.3,
            "parentId": "527617",
            "avgRatingString": "4.3",
            "totalRatingsString": "893",
            "sla": {
                "deliveryTime": 28,
                "lastMileTravel": 2.9,
                "serviceability": "SERVICEABLE",
                "slaString": "25-30 mins",
                "lastMileTravelString": "2.9 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2026-01-30 23:30:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "newg.png",
                        "description": "Gourmet"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Gourmet",
                                    "imageId": "newg.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "ITEMS",
                "subHeader": "AT \u20B9149"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {},
            "externalRatings": {
                "aggregatedRating": {
                    "rating": "--"
                }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
            "context": "seo-data-667c4178-dcb5-482b-a3d1-7c54f6f8faca"
        },
        "cta": {
            "link": "https://www.swiggy.com/city/faridabad/karigari-by-chef-harpal-singh-sokhi-bata-chowk-metro-station-sector-16-fbd-rest792013",
            "type": "WEBLINK"
        }
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "608594",
            name: "Pizza Hut",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/9/1/961a4640-ad96-464d-99a5-13430add9f98_608594.JPG",
            locality: "Sector 15A",
            areaName: "Sector 15A",
            costForTwo: "\u20B9350 for two",
            cuisines: [
                "Pizzas"
            ],
            avgRating: 4.3,
            parentId: "721",
            avgRatingString: "4.3",
            totalRatingsString: "1.5K+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 3,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "3.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 03:45:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "4.0",
                    ratingCount: "2.0K+"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/pizza-hut-sector-15a-rest608594",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "736173",
            name: "Olio - The Wood Fired Pizzeria",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/11/24/90630573-6cc3-4161-a5f2-41ad6396db70_736173.JPG",
            locality: "Neelam Bata Chowk",
            areaName: "Sector 31",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Pizzas",
                "Pastas",
                "Italian",
                "Fast Food",
                "Snacks",
                "Beverages",
                "Desserts"
            ],
            avgRating: 4.2,
            parentId: "11633",
            avgRatingString: "4.2",
            totalRatingsString: "1.9K+",
            sla: {
                deliveryTime: 52,
                lastMileTravel: 8.4,
                serviceability: "SERVICEABLE",
                slaString: "50-60 mins",
                lastMileTravelString: "8.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 05:30:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9119"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/olio-the-wood-fired-pizzeria-neelam-bata-chowk-sector-31-rest736173",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "76444",
            name: "Rama Bhojnalaya (Original since 1975)",
            cloudinaryImageId: "nwmu8u0ngvsr8tkibjx8",
            locality: "Sector 7",
            areaName: "Sector 7",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "North Indian",
                "Indian"
            ],
            avgRating: 4.2,
            veg: true,
            parentId: "15727",
            avgRatingString: "4.2",
            totalRatingsString: "10K+",
            sla: {
                deliveryTime: 33,
                lastMileTravel: 6.3,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "6.3 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-24 23:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "3.9",
                    ratingCount: "1.5K+"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/rama-bhojnalaya-original-since-1975-sector-7-rest76444",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "483339",
            name: "ZAZA Mughal Biryani",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/17/7ecf81cb-2ef7-4ada-92d6-61ec8e6c8653_483339.jpg",
            locality: "Kc Road",
            areaName: "Badkal Lake",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Biryani",
                "North Indian",
                "Awadhi"
            ],
            avgRating: 4.5,
            parentId: "22473",
            avgRatingString: "4.5",
            totalRatingsString: "717",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "Rxawards/_CATEGORY-Biryani.png",
                        description: "Delivery!"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Delivery!",
                                    imageId: "Rxawards/_CATEGORY-Biryani.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/zaza-mughal-biryani-kc-road-badkal-lake-rest483339",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "681599",
            name: "LeanCrust Pizza- ThinCrust Experts",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/30/d97ea843-7c81-4362-a9a9-d55a7054c09c_681599.jpg",
            locality: "K C Road",
            areaName: "New Industrial Township",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Desserts"
            ],
            avgRating: 4.7,
            parentId: "11216",
            avgRatingString: "4.7",
            totalRatingsString: "803",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/leancrust-pizza-thincrust-experts-k-c-road-new-industrial-township-rest681599",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "1151985",
            name: "Zulu's Pizza - Fresh Fanatics",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/7/21/65c93065-98a7-4c77-8141-a7fc3f8e063d_1151985.JPG",
            locality: "KC Road",
            areaName: "Badkal Lake",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Fast Food",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.6,
            parentId: "661655",
            avgRatingString: "4.6",
            totalRatingsString: "17",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            isNewlyOnboarded: true,
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/zulus-pizza-fresh-fanatics-kc-road-badkal-lake-rest1151985",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "643819",
            name: "WeFit - Protein Bowls, Salads & Sandwiches",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/3/ade3c596-ac60-46ce-8c9f-a0cd3fa4e402_643819.jpg",
            locality: "K C Road",
            areaName: "NIT_FBD",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Healthy Food",
                "Salads",
                "Keto",
                "Snacks"
            ],
            avgRating: 4.7,
            parentId: "355285",
            avgRatingString: "4.7",
            totalRatingsString: "866",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "High%20Protein/rx%20tag%205.png",
                        description: "High Protein"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "High Protein",
                                    imageId: "High%20Protein/rx%20tag%205.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9149"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/wefit-protein-bowls-salads-and-sandwiches-k-c-road-nit-fbd-rest643819",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "1219428",
            name: "Salad Days",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/10/8/d39cf270-961f-4f3a-bb8f-dfca91db02ce_1219428.jpg",
            locality: "Post Office",
            areaName: "Sector 16_FBD",
            costForTwo: "\u20B9500 for two",
            cuisines: [
                "Salads"
            ],
            avgRating: 4.7,
            parentId: "796",
            avgRatingString: "4.7",
            totalRatingsString: "71",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 4.2,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "4.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-24 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "High%20Protein/rx%20tag%205.png",
                        description: "High Protein"
                    },
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "High Protein",
                                    imageId: "High%20Protein/rx%20tag%205.png"
                                }
                            },
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            isNewlyOnboarded: true,
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/salad-days-post-office-sector-16-fbd-rest1219428",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "608600",
            name: "Pizza Hut",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/9/1/961a4640-ad96-464d-99a5-13430add9f98_608594.JPG",
            locality: "Sector 15A",
            areaName: "Sector 15A",
            costForTwo: "\u20B9350 for two",
            cuisines: [
                "Pizzas"
            ],
            avgRating: 4.3,
            parentId: "721",
            avgRatingString: "4.3",
            totalRatingsString: "1.5K+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 3,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "3.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 03:45:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "4.0",
                    ratingCount: "2.0K+"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/pizza-hut-sector-15a-rest608594",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "736180",
            name: "Olio - The Wood Fired Pizzeria",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/11/24/90630573-6cc3-4161-a5f2-41ad6396db70_736173.JPG",
            locality: "Neelam Bata Chowk",
            areaName: "Sector 31",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Pizzas",
                "Pastas",
                "Italian",
                "Fast Food",
                "Snacks",
                "Beverages",
                "Desserts"
            ],
            avgRating: 4.2,
            parentId: "11633",
            avgRatingString: "4.2",
            totalRatingsString: "1.9K+",
            sla: {
                deliveryTime: 52,
                lastMileTravel: 8.4,
                serviceability: "SERVICEABLE",
                slaString: "50-60 mins",
                lastMileTravelString: "8.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 05:30:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9119"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/olio-the-wood-fired-pizzeria-neelam-bata-chowk-sector-31-rest736173",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "764785678",
            name: "Rama Bhojnalaya (Original since 1975)",
            cloudinaryImageId: "nwmu8u0ngvsr8tkibjx8",
            locality: "Sector 7",
            areaName: "Sector 7",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "North Indian",
                "Indian"
            ],
            avgRating: 4.2,
            veg: true,
            parentId: "15727",
            avgRatingString: "4.2",
            totalRatingsString: "10K+",
            sla: {
                deliveryTime: 33,
                lastMileTravel: 6.3,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "6.3 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-24 23:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "3.9",
                    ratingCount: "1.5K+"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/rama-bhojnalaya-original-since-1975-sector-7-rest76444",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "48336789",
            name: "ZAZA Mughal Biryani",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/17/7ecf81cb-2ef7-4ada-92d6-61ec8e6c8653_483339.jpg",
            locality: "Kc Road",
            areaName: "Badkal Lake",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Biryani",
                "North Indian",
                "Awadhi"
            ],
            avgRating: 4.5,
            parentId: "22473",
            avgRatingString: "4.5",
            totalRatingsString: "717",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "Rxawards/_CATEGORY-Biryani.png",
                        description: "Delivery!"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Delivery!",
                                    imageId: "Rxawards/_CATEGORY-Biryani.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/zaza-mughal-biryani-kc-road-badkal-lake-rest483339",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "681467",
            name: "LeanCrust Pizza- ThinCrust Experts",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/30/d97ea843-7c81-4362-a9a9-d55a7054c09c_681599.jpg",
            locality: "K C Road",
            areaName: "New Industrial Township",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Desserts"
            ],
            avgRating: 4.7,
            parentId: "11216",
            avgRatingString: "4.7",
            totalRatingsString: "803",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/leancrust-pizza-thincrust-experts-k-c-road-new-industrial-township-rest681599",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "1151345",
            name: "Zulu's Pizza - Fresh Fanatics",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/7/21/65c93065-98a7-4c77-8141-a7fc3f8e063d_1151985.JPG",
            locality: "KC Road",
            areaName: "Badkal Lake",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Fast Food",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.6,
            parentId: "661655",
            avgRatingString: "4.6",
            totalRatingsString: "17",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            isNewlyOnboarded: true,
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/zulus-pizza-fresh-fanatics-kc-road-badkal-lake-rest1151985",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "6435679",
            name: "WeFit - Protein Bowls, Salads & Sandwiches",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/3/ade3c596-ac60-46ce-8c9f-a0cd3fa4e402_643819.jpg",
            locality: "K C Road",
            areaName: "NIT_FBD",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Healthy Food",
                "Salads",
                "Keto",
                "Snacks"
            ],
            avgRating: 4.7,
            parentId: "355285",
            avgRatingString: "4.7",
            totalRatingsString: "866",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.5,
                serviceability: "SERVICEABLE",
                slaString: "20-30 mins",
                lastMileTravelString: "4.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-25 02:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "High%20Protein/rx%20tag%205.png",
                        description: "High Protein"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "High Protein",
                                    imageId: "High%20Protein/rx%20tag%205.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9149"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/wefit-protein-bowls-salads-and-sandwiches-k-c-road-nit-fbd-rest643819",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "121990244",
            name: "Salad Days",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/10/8/d39cf270-961f-4f3a-bb8f-dfca91db02ce_1219428.jpg",
            locality: "Post Office",
            areaName: "Sector 16_FBD",
            costForTwo: "\u20B9500 for two",
            cuisines: [
                "Salads"
            ],
            avgRating: 4.7,
            parentId: "796",
            avgRatingString: "4.7",
            totalRatingsString: "71",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 4.2,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "4.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-11-24 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "High%20Protein/rx%20tag%205.png",
                        description: "High Protein"
                    },
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "High Protein",
                                    imageId: "High%20Protein/rx%20tag%205.png"
                                }
                            },
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            isNewlyOnboarded: true,
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ebb7650b-0214-4448-b37f-fc9d539c693b"
        },
        cta: {
            link: "https://www.swiggy.com/city/faridabad/salad-days-post-office-sector-16-fbd-rest1219428",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    }
];
const $87607fab672c6ed3$export$6f49b4016bfc8d56 = {
    "statusCode": 0,
    "data": {
        "statusMessage": "done successfully",
        "cards": [
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                        "info": {
                            "id": "425",
                            "name": "Hotel Empire",
                            "city": "Bangalore",
                            "slugs": {
                                "restaurant": "hotel-empire-5th-block-koramangala",
                                "city": "bangalore"
                            },
                            "uniqueId": "79848f6e-cd46-4b74-b127-d1fc3af3256c",
                            "cloudinaryImageId": "un4omn7rcunkmlw6vikr",
                            "locality": "Koramangala",
                            "areaName": "Koramangala",
                            "costForTwo": "45000",
                            "costForTwoMessage": "\u20B9450 for two",
                            "cuisines": [
                                "North Indian",
                                "Kebabs"
                            ],
                            "avgRating": 4.1,
                            "feeDetails": {
                                "restaurantId": "425",
                                "fees": [
                                    {
                                        "name": "distance",
                                        "fee": 3300
                                    },
                                    {
                                        "name": "time"
                                    },
                                    {
                                        "name": "special"
                                    }
                                ],
                                "totalFee": 3300,
                                "title": "Delivery Charge",
                                "amount": "3300"
                            },
                            "parentId": "475",
                            "avgRatingString": "4.1",
                            "totalRatingsString": "10K+ ratings",
                            "sla": {
                                "restaurantId": "425",
                                "deliveryTime": 22,
                                "minDeliveryTime": 22,
                                "maxDeliveryTime": 22,
                                "lastMileTravel": 1.3,
                                "serviceability": "SERVICEABLE",
                                "stressFactor": 0.736653,
                                "rainMode": "RAIN_MODE_NONE",
                                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                                "zoneId": 1,
                                "slaString": "22 MINS",
                                "lastMileTravelString": "1.2 km",
                                "iconType": "ICON_TYPE_EMPTY"
                            },
                            "availability": {
                                "nextCloseTime": "2023-07-30 05:00:00",
                                "visibility": true,
                                "opened": true,
                                "restaurantClosedMeta": {}
                            },
                            "aggregatedDiscountInfo": {
                                "header": "10% off",
                                "shortDescriptionList": [
                                    {
                                        "meta": "10% off | Use TRYNEW",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "meta": "10% off | Use PARTY",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "descriptionList": [
                                    {
                                        "meta": "10% off up to \u20B940 | Use code TRYNEW",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "meta": "10% off | Use code PARTY",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "visible": true
                            },
                            "badges": {},
                            "slugString": "hotel-empire-5th-block-koramangala",
                            "multiOutlet": true,
                            "isOpen": true,
                            "labels": [
                                {
                                    "title": "Timings",
                                    "message": "null"
                                },
                                {
                                    "title": "Address",
                                    "message": "103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore"
                                },
                                {
                                    "title": "Cuisines",
                                    "message": "North Indian,Kebabs"
                                }
                            ],
                            "totalRatings": 10000,
                            "aggregatedDiscountInfoV2": {
                                "header": "10% off",
                                "shortDescriptionList": [
                                    {
                                        "meta": "10% off | Use TRYNEW",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "meta": "10% off | Use PARTY",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "descriptionList": [
                                    {
                                        "meta": "10% off up to \u20B940 | Use code TRYNEW",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "meta": "10% off | Use code PARTY",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "couponDetailsCta": "View coupon details"
                            },
                            "type": "F",
                            "nudgeBanners": [
                                {
                                    "minValue": 350,
                                    "maxValue": 500,
                                    "priority": 2,
                                    "couponCode": "PARTY",
                                    "discountInfo": {
                                        "discountType": "Percentage",
                                        "value": 10
                                    },
                                    "lockedMessage": "Add items worth \u20B9<amount> to unlock flat 10% off | Code PARTY",
                                    "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 10% off",
                                    "logoCtx": {}
                                }
                            ],
                            "headerBanner": {
                                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/425"
                            },
                            "expectationNotifiers": [
                                {
                                    "icon": {},
                                    "popup": {
                                        "cta": {}
                                    },
                                    "type": "DISTANCE_FEE_NON_FOOD_LM",
                                    "halfCardPopup": {
                                        "halfCardPopupHeader": {}
                                    }
                                }
                            ],
                            "generalPurposeInfoListV2": [
                                {
                                    "cta": {
                                        "info": {
                                            "recordings": {}
                                        },
                                        "linkCta": {}
                                    }
                                }
                            ],
                            "ratingSlab": "RATING_SLAB_5",
                            "orderabilityCommunication": {
                                "title": {},
                                "subTitle": {},
                                "message": {},
                                "customIcon": {}
                            },
                            "hasBestsellerItems": true,
                            "cartOrderabilityNudgeBanner": {
                                "parameters": {},
                                "presentation": {}
                            },
                            "latLong": "12.934816,77.61580500000002"
                        },
                        "analytics": {}
                    },
                    "relevance": {
                        "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
                        "sectionId": "POP_UP_CROUTON_MENU"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "layout": {
                            "rows": 1,
                            "columns": 4,
                            "horizontalScrollEnabled": true,
                            "itemSpacing": 12,
                            "lineSpacing": 10,
                            "widgetPadding": {},
                            "containerStyle": {
                                "containerPadding": {
                                    "left": 10,
                                    "right": 10,
                                    "bottom": 16
                                }
                            },
                            "scrollBar": {}
                        },
                        "id": "offerCollectionWidget_UX4",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                                "offers": [
                                    {
                                        "info": {
                                            "header": "10% OFF UPTO \u20B940",
                                            "offerTagColor": "#E46D47",
                                            "offerIds": [
                                                "65d416bb-4aa9-49cd-9c8b-241f30b30484"
                                            ],
                                            "expiryTime": "1970-01-01T00:00:00Z",
                                            "couponCode": "USE TRYNEW",
                                            "description": "ABOVE \u20B9159",
                                            "offerType": "offers",
                                            "restId": "425",
                                            "offerLogo": "offers/generic",
                                            "descriptionTextColor": "#7302060C"
                                        },
                                        "cta": {
                                            "type": "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        "info": {
                                            "header": "FLAT 10% OFF",
                                            "offerTag": "FLAT DEAL",
                                            "offerTagColor": "#E46D47",
                                            "offerIds": [
                                                "6e9bcb18-a206-46d8-a9c7-268b855d1273"
                                            ],
                                            "expiryTime": "1970-01-01T00:00:00Z",
                                            "couponCode": "USE PARTY",
                                            "description": "ABOVE \u20B9500",
                                            "offerType": "offers",
                                            "restId": "425",
                                            "offerLogo": "offers/generic",
                                            "descriptionTextColor": "#7302060C"
                                        },
                                        "cta": {
                                            "type": "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        "info": {
                                            "header": "30% OFF UPTO \u20B975",
                                            "offerTagColor": "#E46D47",
                                            "logoBottom": "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
                                            "offerIds": [
                                                "e914d8fd-1192-49a8-97c9-24e29cd698e4"
                                            ],
                                            "expiryTime": "1970-01-01T00:00:00Z",
                                            "couponCode": "NO CODE REQUIRED",
                                            "description": "ABOVE \u20B9199",
                                            "offerType": "offers",
                                            "restId": "425",
                                            "offerLogo": "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
                                            "descriptionTextColor": "#7302060C"
                                        },
                                        "cta": {
                                            "type": "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        "info": {
                                            "header": "15% OFF UPTO \u20B9300",
                                            "offerTagColor": "#E46D47",
                                            "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                                            "offerIds": [
                                                "ab6ca12d-e322-409c-8396-4b287bdeaf02"
                                            ],
                                            "expiryTime": "1970-01-01T00:00:00Z",
                                            "couponCode": "USE CITIFOODIE",
                                            "description": "ABOVE \u20B91200",
                                            "offerType": "offers",
                                            "restId": "425",
                                            "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                                            "descriptionTextColor": "#7302060C"
                                        },
                                        "cta": {
                                            "type": "OFFER_HALF_CARD"
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            },
            {
                "groupedCard": {
                    "cardGroupMap": {
                        "REGULAR": {
                            "cards": [
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                            "badges": {},
                                            "vegOnlyDetails": {
                                                "imageId": "AutoVegOnly_qkjowj",
                                                "title": "Showing only vegetarian options.",
                                                "description": "Tap on the VEG ONLY button to turn off the setting"
                                            },
                                            "topRatedFilter": {}
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Recommended",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669680",
                                                            "name": "Bucket Chicken Biriyani",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "o3md7bihfchbxxrcfbgu",
                                                            "inStock": 1,
                                                            "price": 126000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924013",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842130",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842149",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842126",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842122",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842154",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842158",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "49 ratings",
                                                                    "ratingCountV2": "49"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669684",
                                                            "name": "Bucket Biriyani With Chicken Kabab",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "ivjkz6qcirckeynmccj1",
                                                            "inStock": 1,
                                                            "price": 157500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924037",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842345",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842369",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842342",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842338",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842390",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842393",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "16 ratings",
                                                                    "ratingCountV2": "16"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669685",
                                                            "name": "Bucket Biriyani With Fiery Wings",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "qvnrbktvk7whi0qzcoau",
                                                            "inStock": 1,
                                                            "price": 163100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924045",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842447",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842459",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842443",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842440",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842472",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842475",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669686",
                                                            "name": "Bucket Biriyani With Kalmi Kabab",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "kmz6vppi99urueddhba4",
                                                            "inStock": 1,
                                                            "price": 167000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924051",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842505",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842545",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842499",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842495",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842562",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842565",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822532",
                                                            "name": "Empire Special Chilly Kebab",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "mwjxnsys86a5apetncxm",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810824",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 420,
                                                                                "id": "18813851",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 215,
                                                                                "id": "18813850",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 125,
                                                                                "default": 1,
                                                                                "id": "18813849",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810824",
                                                                                "variationId": "18813851"
                                                                            }
                                                                        ],
                                                                        "price": 42000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810824",
                                                                                "variationId": "18813850"
                                                                            }
                                                                        ],
                                                                        "price": 21500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810824",
                                                                                "variationId": "18813849"
                                                                            }
                                                                        ],
                                                                        "price": 12500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835949",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835953",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835944",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835960",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 12500,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "405 ratings",
                                                                    "ratingCountV2": "405"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "4300494",
                                                            "name": "Popcorn Chicken Kebab",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "irvoj3hrrcsu5t5n3wx8",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810784",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 490,
                                                                                "id": "18813738",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813737",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 137,
                                                                                "default": 1,
                                                                                "id": "18813736",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810784",
                                                                                "variationId": "18813738"
                                                                            }
                                                                        ],
                                                                        "price": 49000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810784",
                                                                                "variationId": "18813737"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810784",
                                                                                "variationId": "18813736"
                                                                            }
                                                                        ],
                                                                        "price": 13700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835113",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835120",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835111",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835125",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13700,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "859 ratings",
                                                                    "ratingCountV2": "859"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215037",
                                                            "name": "Grilled Chicken",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "wyxryeipwcmz4q6hen2h",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810794",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 420,
                                                                                "id": "18813765",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 214,
                                                                                "default": 1,
                                                                                "id": "18813764",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810794",
                                                                                "variationId": "18813765"
                                                                            }
                                                                        ],
                                                                        "price": 42000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866479",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810794",
                                                                                "variationId": "18813764"
                                                                            }
                                                                        ],
                                                                        "price": 21400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866479",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835557",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835568",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835542",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835580",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67866479",
                                                                    "groupName": "Bread",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54168863",
                                                                            "name": "Kuboos",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 21400,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "9402 ratings",
                                                                    "ratingCountV2": "9402"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822505",
                                                            "name": "Empire Special Chicken Kebab",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "obqi7kmdulkmoyrbbx1g",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810800",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 377,
                                                                                "id": "18813783",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 194,
                                                                                "id": "18813782",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 107,
                                                                                "default": 1,
                                                                                "id": "18813781",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810800",
                                                                                "variationId": "18813783"
                                                                            }
                                                                        ],
                                                                        "price": 37700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810800",
                                                                                "variationId": "18813782"
                                                                            }
                                                                        ],
                                                                        "price": 19400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810800",
                                                                                "variationId": "18813781"
                                                                            }
                                                                        ],
                                                                        "price": 10700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835673",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835677",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835670",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835696",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 10700,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "5116 ratings",
                                                                    "ratingCountV2": "5116"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215167",
                                                            "name": "Lemon Rice",
                                                            "category": "Rice",
                                                            "description": "Serves 1",
                                                            "imageId": "vgmmxxdnxv06pjgf3ksw",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808621",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 139,
                                                                                "default": 1,
                                                                                "id": "77096183",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 139,
                                                                                "id": "77096184",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808621",
                                                                                "variationId": "77096183"
                                                                            }
                                                                        ],
                                                                        "price": 13900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841593",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808621",
                                                                                "variationId": "77096184"
                                                                            }
                                                                        ],
                                                                        "price": 13900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841593",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67841561",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841578",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841555",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841551",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841593",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841598",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13900,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "309 ratings",
                                                                    "ratingCountV2": "309"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215110",
                                                            "name": "Chicken Tikka Masala",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "icpycagtwmqflonmjud8",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810906",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 515,
                                                                                "id": "18814079",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 273,
                                                                                "id": "18814078",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 153,
                                                                                "default": 1,
                                                                                "id": "18814077",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810906",
                                                                                "variationId": "18814079"
                                                                            }
                                                                        ],
                                                                        "price": 51500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923857",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810906",
                                                                                "variationId": "18814078"
                                                                            }
                                                                        ],
                                                                        "price": 27300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923857",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810906",
                                                                                "variationId": "18814077"
                                                                            }
                                                                        ],
                                                                        "price": 15300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923857",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923857",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839762",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839769",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839808",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15300,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "1070 ratings",
                                                                    "ratingCountV2": "1070"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822601",
                                                            "name": "Butter Chicken Boneless",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "vbtgihmcmseeizl1iuma",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810875",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18813991",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 265,
                                                                                "id": "18813990",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 153,
                                                                                "default": 1,
                                                                                "id": "18813989",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810875",
                                                                                "variationId": "18813991"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923621",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810875",
                                                                                "variationId": "18813990"
                                                                            }
                                                                        ],
                                                                        "price": 26500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923621",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810875",
                                                                                "variationId": "18813989"
                                                                            }
                                                                        ],
                                                                        "price": 15300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923621",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923621",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837898",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837909",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837929",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15300,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "949 ratings",
                                                                    "ratingCountV2": "949"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822617",
                                                            "name": "Chicken Varval",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "mk3acltmonkzutknsqny",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810887",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 480,
                                                                                "id": "18814025",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18814024",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18814023",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810887",
                                                                                "variationId": "18814025"
                                                                            }
                                                                        ],
                                                                        "price": 48000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923663",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810887",
                                                                                "variationId": "18814024"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923663",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810887",
                                                                                "variationId": "18814023"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923663",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923663",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838418",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838427",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838446",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "258 ratings",
                                                                    "ratingCountV2": "258"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215186",
                                                            "name": "Ceylon Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "ediibdf3gsujqd6ifutq",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808578",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 37,
                                                                                "default": 1,
                                                                                "id": "77096099",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 37,
                                                                                "id": "77096100",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808578",
                                                                                "variationId": "77096099"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808578",
                                                                                "variationId": "77096100"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836362",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836368",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836374",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3700,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "1017 ratings",
                                                                    "ratingCountV2": "1017"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215187",
                                                            "name": "Coin Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "fmfupmuieyd62gfdcddh",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808597",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 30,
                                                                                "default": 1,
                                                                                "id": "77096135",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 30,
                                                                                "id": "77096136",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808597",
                                                                                "variationId": "77096135"
                                                                            }
                                                                        ],
                                                                        "price": 3000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808597",
                                                                                "variationId": "77096136"
                                                                            }
                                                                        ],
                                                                        "price": 3000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838789",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838811",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838847",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3000,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "1804 ratings",
                                                                    "ratingCountV2": "1804"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215175",
                                                            "name": "Kulcha",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "bzdjx3rqgccz6iuyyk0b",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "24090406",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 35,
                                                                                "default": 1,
                                                                                "id": "77727447",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 35,
                                                                                "id": "77727448",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090406",
                                                                                "variationId": "77727447"
                                                                            }
                                                                        ],
                                                                        "price": 3500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090406",
                                                                                "variationId": "77727448"
                                                                            }
                                                                        ],
                                                                        "price": 3500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839052",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839089",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839103",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3500,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "1067 ratings",
                                                                    "ratingCountV2": "1067"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215089",
                                                            "name": "Dal Fry",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "imageId": "jxxtujwekfghedg6axk1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810896",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 122,
                                                                                "id": "18814050",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 71,
                                                                                "default": 1,
                                                                                "id": "18814049",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810896",
                                                                                "variationId": "18814050"
                                                                            }
                                                                        ],
                                                                        "price": 12200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923715",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810896",
                                                                                "variationId": "18814049"
                                                                            }
                                                                        ],
                                                                        "price": 7100,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923715",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923715",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838709",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838720",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838750",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 7100,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "1319 ratings",
                                                                    "ratingCountV2": "1319"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215084",
                                                            "name": "Paneer Butter Masala",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "imageId": "aebk3ggsozr3gtijronv",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810851",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 189,
                                                                                "id": "18813925",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 112,
                                                                                "default": 1,
                                                                                "id": "18813924",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810851",
                                                                                "variationId": "18813925"
                                                                            }
                                                                        ],
                                                                        "price": 18900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923559",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810851",
                                                                                "variationId": "18813924"
                                                                            }
                                                                        ],
                                                                        "price": 11200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923559",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923559",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836806",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836836",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836847",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 11200,
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "2157 ratings",
                                                                    "ratingCountV2": "2157"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104035812",
                                                            "name": "Chocolate Mousse",
                                                            "category": "Juice Shop",
                                                            "description": "Serves 1",
                                                            "imageId": "rkufmtlhzq2ufiuqs5on",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104035813",
                                                            "name": "Hot Chocolate Fudge",
                                                            "category": "Juice Shop",
                                                            "description": "Serves 1",
                                                            "imageId": "l6sxj0dmltdp1yaoeaym",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "28309444",
                                                            "name": "Death By Chocolate",
                                                            "category": "Juice Shop",
                                                            "description": "Serves 1 | DBC is everyone\u2019s favourite. Scoops of rich and creamy vanilla ice cream with of a warm homemade chocolate cake sponge, drizzled with our signature homemade DBC sauce and roasted peanuts is an absolute treat for every dessert lover.",
                                                            "imageId": "lvhxynldslndyn4u02ma",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.1",
                                                                    "ratingCount": "42 ratings",
                                                                    "ratingCountV2": "42"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "96906011",
                                                            "name": "Avocado Thick Shake",
                                                            "category": "Juice Shop",
                                                            "description": "Serves 1",
                                                            "imageId": "pxyhxnyqzsqrfrddomo6",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "14 ratings",
                                                                    "ratingCountV2": "14"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "100217612",
                                                            "name": "Matka Kulfi",
                                                            "category": "Juice Shop",
                                                            "description": "Serves 1",
                                                            "imageId": "knpo2manobuiagemdkib",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 8900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "showImage": true,
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "13 ratings",
                                                                    "ratingCountV2": "13"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ],
                                            "type": "CATEGORY_TYPE_RECOMMENDED"
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Biriyani",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822517",
                                                            "name": "Egg Biriyani",
                                                            "category": "Biriyani",
                                                            "description": "Serves 1",
                                                            "imageId": "estud4jfulsslglmzges",
                                                            "inStock": 1,
                                                            "price": 21400,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923986",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841797",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841860",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841791",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841790",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841929",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841944",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "137 ratings",
                                                                    "ratingCountV2": "137"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822514",
                                                            "name": "Prawns Biriyani",
                                                            "category": "Biriyani",
                                                            "description": "Serves 1",
                                                            "imageId": "advclisbcydlpxmr8xds",
                                                            "inStock": 1,
                                                            "price": 33700,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923965",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841325",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891832",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841320",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841316",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841340",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841345",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "60 ratings",
                                                                    "ratingCountV2": "60"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822519",
                                                            "name": "Chicken Biriyani",
                                                            "category": "Biriyani",
                                                            "description": "Serves 1",
                                                            "imageId": "wxiqzeafmwowtfuskf1z",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810810",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "LARGE",
                                                                                "price": 295,
                                                                                "id": "18813809",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "REGULAR",
                                                                                "price": 180,
                                                                                "default": 1,
                                                                                "id": "18813808",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810810",
                                                                                "variationId": "18813809"
                                                                            }
                                                                        ],
                                                                        "price": 29500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923396",
                                                                                "addonId": "54935061"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67864966",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67864966",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67864966",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67864965",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67864965",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67891740",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810810",
                                                                                "variationId": "18813808"
                                                                            }
                                                                        ],
                                                                        "price": 18000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923396",
                                                                                "addonId": "54935061"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67864967",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67864971",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67864966",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67864966",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67864966",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67864965",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67864965",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67891740",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67864973",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923396",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67864967",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67864971",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67864966",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67864965",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891740",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67864973",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 18000,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "1443 ratings",
                                                                    "ratingCountV2": "1443"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822520",
                                                            "name": "Veg Biriyani",
                                                            "category": "Biriyani",
                                                            "description": "Serves 1",
                                                            "imageId": "kklrjlpk5igqswxwfrga",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 21400,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67841197",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841228",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841173",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841165",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841251",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841256",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "84 ratings",
                                                                    "ratingCountV2": "84"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822576",
                                                            "name": "Biriyani Rice (non Veg)",
                                                            "category": "Biriyani",
                                                            "description": "Serves 1",
                                                            "imageId": "yaou4iakzffgz8zl8rhj",
                                                            "inStock": 1,
                                                            "price": 13000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924001",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842001",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842039",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841997",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841992",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842072",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842075",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "458 ratings",
                                                                    "ratingCountV2": "458"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Combo Meals",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "54867885",
                                                            "name": "Ghee Rice With Dal Fry",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Ghee Rice, Dal Fry.",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67843725",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843732",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843778",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843709",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843800",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "329 ratings",
                                                                    "ratingCountV2": "329"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624514",
                                                            "name": "Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Ghee Rice, Paneer Butter Masala (5 pcs), Gobi Manchurian",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67891925",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891926",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891927",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891924",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891928",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "346 ratings",
                                                                    "ratingCountV2": "346"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624515",
                                                            "name": "Veg Fried Rice & Gobi Manchurian",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Veg Fried Rice, Gobi Manchurian.",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67843844",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843851",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843869",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843841",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843922",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "58 ratings",
                                                                    "ratingCountV2": "58"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624505",
                                                            "name": "2 Naan, Paneer Butter Masala, Gobi Manchurian",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | 2Naan,Paneer Butter Masala (5 pcs),Gobi Manchurian",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67843065",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843070",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843093",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843063",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843115",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "156 ratings",
                                                                    "ratingCountV2": "156"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624502",
                                                            "name": "3 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Coin Parotta (2 Nos), Hyderabadi Chicken Boneless (5 Pcs), Popcorn Kebab (5 Pcs)",
                                                            "inStock": 1,
                                                            "price": 20900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67842919",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842930",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842970",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842917",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843025",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "127 ratings",
                                                                    "ratingCountV2": "127"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624506",
                                                            "name": "Biriyani Rice, Raitha & Pepper Chicken Boneless",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Biriyani Rice, Raitha, Pepper Chicken Bonless (5 Pcs)",
                                                            "inStock": 1,
                                                            "price": 16900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924069",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843182",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843204",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843233",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843187",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843167",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843253",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "214 ratings",
                                                                    "ratingCountV2": "214"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624507",
                                                            "name": "Chicken Biriyani (Regular), Raitha &Popcorn Kebab",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Chicken Biriyani (Regular), Raitha, Popcorn Kebab (5 Pcs)",
                                                            "inStock": 1,
                                                            "price": 20900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924078",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843313",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843333",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843354",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843325",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843309",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843383",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "222 ratings",
                                                                    "ratingCountV2": "222"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624508",
                                                            "name": "Ghee Rice Butter Chicken Combo",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Ghee Rice, Butter Chicken Boneless (5 Pcs).",
                                                            "inStock": 1,
                                                            "price": 14900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67843426",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843450",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843491",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843423",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843520",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "339 ratings",
                                                                    "ratingCountV2": "339"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "85624509",
                                                            "name": "Ghee Rice, Butter Chicken Combo & Chicken Manchurian Dry",
                                                            "category": "Empire Special Combo Meals",
                                                            "description": "Serves 1 | Ghee Rice, Butter Chicken Boneless (5 Pcs), Manchurian Dry (5 Pcs)",
                                                            "inStock": 1,
                                                            "price": 18900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67843583",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843595",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843631",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843557",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67843649",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "509 ratings",
                                                                    "ratingCountV2": "509"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Biryani",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215160",
                                                            "name": "Grilled Chicken Biryani",
                                                            "category": "Empire Special Biryani",
                                                            "description": "Serves 1",
                                                            "imageId": "zmz8cvbu6lstifyvdftl",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "12307838",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 698,
                                                                                "id": "40195395",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 372,
                                                                                "default": 1,
                                                                                "id": "40195396",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "12307838",
                                                                                "variationId": "40195395"
                                                                            }
                                                                        ],
                                                                        "price": 69800,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923415",
                                                                                "addonId": "54935061"
                                                                            },
                                                                            {
                                                                                "groupId": "67835796",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835796",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835796",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835809",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835809",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835809",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835802",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835802",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835802",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835792",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67835792",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67835828",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "12307838",
                                                                                "variationId": "40195396"
                                                                            }
                                                                        ],
                                                                        "price": 37200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923415",
                                                                                "addonId": "54935061"
                                                                            },
                                                                            {
                                                                                "groupId": "67835796",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835796",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835796",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835816",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835809",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835809",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835809",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835824",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835802",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835802",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835802",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835792",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67835792",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67835828",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835830",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923415",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835796",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835816",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835809",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835824",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835802",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835792",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835828",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835830",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 37200,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "379 ratings",
                                                                    "ratingCountV2": "379"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Bucket Biriyani",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669680",
                                                            "name": "Bucket Chicken Biriyani",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "o3md7bihfchbxxrcfbgu",
                                                            "inStock": 1,
                                                            "price": 126000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924013",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842130",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842149",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842126",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842122",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842154",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842158",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "49 ratings",
                                                                    "ratingCountV2": "49"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669682",
                                                            "name": "Bucket Biriyani With Grilled Chicken",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "inStock": 1,
                                                            "price": 161700,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924023",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842237",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842257",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842229",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842216",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842187",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842299",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842302",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891844",
                                                                    "groupName": "Bread",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54168863",
                                                                            "name": "Kuboos",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "9 ratings",
                                                                    "ratingCountV2": "9"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669684",
                                                            "name": "Bucket Biriyani With Chicken Kabab",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "ivjkz6qcirckeynmccj1",
                                                            "inStock": 1,
                                                            "price": 157500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924037",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842345",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842369",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842342",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842338",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842390",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842393",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "16 ratings",
                                                                    "ratingCountV2": "16"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669685",
                                                            "name": "Bucket Biriyani With Fiery Wings",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "qvnrbktvk7whi0qzcoau",
                                                            "inStock": 1,
                                                            "price": 163100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924045",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842447",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842459",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842443",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842440",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842472",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842475",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65669686",
                                                            "name": "Bucket Biriyani With Kalmi Kabab",
                                                            "category": "Bucket Biriyani",
                                                            "description": "Serves 7",
                                                            "imageId": "kmz6vppi99urueddhba4",
                                                            "inStock": 1,
                                                            "price": 167000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924051",
                                                                    "groupName": "Egg",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935061",
                                                                            "name": "Boiled Egg",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842505",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842545",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842499",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842495",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842562",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842565",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 7"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Chicken (Dry)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822614",
                                                            "name": "Pepper Chicken Dry Boneless",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "jzjh2o2tntz1kpp8bxug",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810885",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 480,
                                                                                "id": "18814020",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 252,
                                                                                "id": "18814019",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18814018",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810885",
                                                                                "variationId": "18814020"
                                                                            }
                                                                        ],
                                                                        "price": 48000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810885",
                                                                                "variationId": "18814019"
                                                                            }
                                                                        ],
                                                                        "price": 25200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810885",
                                                                                "variationId": "18814018"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67838284",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838289",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67838281",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838304",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838284",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838289",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838281",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838304",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "560 ratings",
                                                                    "ratingCountV2": "560"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822532",
                                                            "name": "Empire Special Chilly Kebab",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "mwjxnsys86a5apetncxm",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810824",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 420,
                                                                                "id": "18813851",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 215,
                                                                                "id": "18813850",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 125,
                                                                                "default": 1,
                                                                                "id": "18813849",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810824",
                                                                                "variationId": "18813851"
                                                                            }
                                                                        ],
                                                                        "price": 42000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810824",
                                                                                "variationId": "18813850"
                                                                            }
                                                                        ],
                                                                        "price": 21500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810824",
                                                                                "variationId": "18813849"
                                                                            }
                                                                        ],
                                                                        "price": 12500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835949",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835953",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835944",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835960",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835949",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835953",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835944",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835960",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 12500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "405 ratings",
                                                                    "ratingCountV2": "405"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215032",
                                                            "name": "Pepper Chicken Dry",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "nrx3bnvkrvjblpwnejze",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810789",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 449,
                                                                                "id": "18813752",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 235,
                                                                                "id": "18813751",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 133,
                                                                                "default": 1,
                                                                                "id": "18813750",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810789",
                                                                                "variationId": "18813752"
                                                                            }
                                                                        ],
                                                                        "price": 44900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810789",
                                                                                "variationId": "18813751"
                                                                            }
                                                                        ],
                                                                        "price": 23500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810789",
                                                                                "variationId": "18813750"
                                                                            }
                                                                        ],
                                                                        "price": 13300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835314",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835323",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835302",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835327",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835314",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835323",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835302",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835327",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "454 ratings",
                                                                    "ratingCountV2": "454"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822578",
                                                            "name": "Chilly Chicken Dry",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "yhq0iyriltkxoyh0yqyl",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810860",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 449,
                                                                                "id": "18813951",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 235,
                                                                                "id": "18813950",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 133,
                                                                                "default": 1,
                                                                                "id": "18813949",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810860",
                                                                                "variationId": "18813951"
                                                                            }
                                                                        ],
                                                                        "price": 44900
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810860",
                                                                                "variationId": "18813950"
                                                                            }
                                                                        ],
                                                                        "price": 23500
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810860",
                                                                                "variationId": "18813949"
                                                                            }
                                                                        ],
                                                                        "price": 13300
                                                                    }
                                                                ]
                                                            },
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "151 ratings",
                                                                    "ratingCountV2": "151"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "4300494",
                                                            "name": "Popcorn Chicken Kebab",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "irvoj3hrrcsu5t5n3wx8",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810784",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 490,
                                                                                "id": "18813738",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813737",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 137,
                                                                                "default": 1,
                                                                                "id": "18813736",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810784",
                                                                                "variationId": "18813738"
                                                                            }
                                                                        ],
                                                                        "price": 49000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810784",
                                                                                "variationId": "18813737"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810784",
                                                                                "variationId": "18813736"
                                                                            }
                                                                        ],
                                                                        "price": 13700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835113",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835120",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835111",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835125",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835113",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835120",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835111",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835125",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "859 ratings",
                                                                    "ratingCountV2": "859"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215037",
                                                            "name": "Grilled Chicken",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "wyxryeipwcmz4q6hen2h",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810794",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 420,
                                                                                "id": "18813765",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 214,
                                                                                "default": 1,
                                                                                "id": "18813764",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810794",
                                                                                "variationId": "18813765"
                                                                            }
                                                                        ],
                                                                        "price": 42000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866479",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810794",
                                                                                "variationId": "18813764"
                                                                            }
                                                                        ],
                                                                        "price": 21400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835557",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835568",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835542",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835580",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866479",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835557",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835568",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835542",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835580",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67866479",
                                                                    "groupName": "Bread",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54168863",
                                                                            "name": "Kuboos",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 21400,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "9402 ratings",
                                                                    "ratingCountV2": "9402"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822492",
                                                            "name": "Chicken Kebab Boneless",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "sexytz31r1pqfx5xomd5",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810786",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 490,
                                                                                "id": "18813744",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813743",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 132,
                                                                                "default": 1,
                                                                                "id": "18813742",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810786",
                                                                                "variationId": "18813744"
                                                                            }
                                                                        ],
                                                                        "price": 49000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810786",
                                                                                "variationId": "18813743"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810786",
                                                                                "variationId": "18813742"
                                                                            }
                                                                        ],
                                                                        "price": 13200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835237",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835242",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835230",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835275",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835237",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835242",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835230",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835275",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13200,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "388 ratings",
                                                                    "ratingCountV2": "388"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822505",
                                                            "name": "Empire Special Chicken Kebab",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "obqi7kmdulkmoyrbbx1g",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810800",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 377,
                                                                                "id": "18813783",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 194,
                                                                                "id": "18813782",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 107,
                                                                                "default": 1,
                                                                                "id": "18813781",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810800",
                                                                                "variationId": "18813783"
                                                                            }
                                                                        ],
                                                                        "price": 37700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810800",
                                                                                "variationId": "18813782"
                                                                            }
                                                                        ],
                                                                        "price": 19400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810800",
                                                                                "variationId": "18813781"
                                                                            }
                                                                        ],
                                                                        "price": 10700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835673",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835677",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835670",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835696",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835673",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835677",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835670",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835696",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 10700,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "5116 ratings",
                                                                    "ratingCountV2": "5116"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822547",
                                                            "name": "Alfaham Chicken",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "2e675d94449140ec4a4954c992533725",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810833",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 462,
                                                                                "id": "18813875",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 245,
                                                                                "id": "18813874",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 138,
                                                                                "default": 1,
                                                                                "id": "18813873",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810833",
                                                                                "variationId": "18813875"
                                                                            }
                                                                        ],
                                                                        "price": 46200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866511",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810833",
                                                                                "variationId": "18813874"
                                                                            }
                                                                        ],
                                                                        "price": 24500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866511",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810833",
                                                                                "variationId": "18813873"
                                                                            }
                                                                        ],
                                                                        "price": 13800,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836197",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836203",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836191",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836215",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866511",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836197",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836203",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836191",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836215",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67866511",
                                                                    "groupName": "Bread",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54168863",
                                                                            "name": "Kuboos",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13800,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "910 ratings",
                                                                    "ratingCountV2": "910"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822573",
                                                            "name": "Chicken Manchurian Boneless",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "gloajcuovqkezogtpfud",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "8244229",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 484,
                                                                                "id": "27551810",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 252,
                                                                                "id": "27551809",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 137,
                                                                                "default": 1,
                                                                                "id": "27551808",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "8244229",
                                                                                "variationId": "27551810"
                                                                            }
                                                                        ],
                                                                        "price": 48400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "8244229",
                                                                                "variationId": "27551809"
                                                                            }
                                                                        ],
                                                                        "price": 25200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "8244229",
                                                                                "variationId": "27551808"
                                                                            }
                                                                        ],
                                                                        "price": 13700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836982",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836987",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836975",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836998",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836982",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836987",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836975",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836998",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "182 ratings",
                                                                    "ratingCountV2": "182"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822609",
                                                            "name": "Chilly Chicken Boneless",
                                                            "category": "Empire Special Chicken (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "jkyfek2e4uuwxduqec89",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810879",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 470,
                                                                                "id": "18814002",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 247,
                                                                                "id": "18814001",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 140,
                                                                                "default": 1,
                                                                                "id": "18814000",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810879",
                                                                                "variationId": "18814002"
                                                                            }
                                                                        ],
                                                                        "price": 47000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810879",
                                                                                "variationId": "18814001"
                                                                            }
                                                                        ],
                                                                        "price": 24700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810879",
                                                                                "variationId": "18814000"
                                                                            }
                                                                        ],
                                                                        "price": 14000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67838071",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838079",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67838067",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838091",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838071",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838079",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838067",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838091",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "303 ratings",
                                                                    "ratingCountV2": "303"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Tandoori(dry)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822501",
                                                            "name": "Kalmi Kabab",
                                                            "category": "Tandoori(dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "ymipyekw4xeq0mkufsl8",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810797",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18813774",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 275,
                                                                                "id": "18813773",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 150,
                                                                                "default": 1,
                                                                                "id": "18813772",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810797",
                                                                                "variationId": "18813774"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810797",
                                                                                "variationId": "18813773"
                                                                            }
                                                                        ],
                                                                        "price": 27500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810797",
                                                                                "variationId": "18813772"
                                                                            }
                                                                        ],
                                                                        "price": 15000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67835637",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67835627",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835642",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835637",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835627",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835642",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "73 ratings",
                                                                    "ratingCountV2": "73"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822570",
                                                            "name": "Murg Tikka",
                                                            "category": "Tandoori(dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "nncv1qc5djsgljrs2eoz",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810850",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18813923",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813922",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 150,
                                                                                "default": 1,
                                                                                "id": "18813921",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810850",
                                                                                "variationId": "18813923"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810850",
                                                                                "variationId": "18813922"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810850",
                                                                                "variationId": "18813921"
                                                                            }
                                                                        ],
                                                                        "price": 15000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67836747",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67836743",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836756",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836747",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836743",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836756",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "41 ratings",
                                                                    "ratingCountV2": "41"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822628",
                                                            "name": "Murg Hariyali Tikka",
                                                            "category": "Tandoori(dry)",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810898",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18814056",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18814055",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 150,
                                                                                "default": 1,
                                                                                "id": "18814054",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810898",
                                                                                "variationId": "18814056"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810898",
                                                                                "variationId": "18814055"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810898",
                                                                                "variationId": "18814054"
                                                                            }
                                                                        ],
                                                                        "price": 15000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67839024",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67839017",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839035",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839024",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839017",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839035",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "defaultPrice": 15000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.3",
                                                                    "ratingCount": "362 ratings",
                                                                    "ratingCountV2": "362"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822660",
                                                            "name": "Tandoori Chicken",
                                                            "category": "Tandoori(dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "gb5pcoodwyyssr9fjgjl",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810925",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 460,
                                                                                "id": "18814130",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 245,
                                                                                "id": "18814129",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 140,
                                                                                "default": 1,
                                                                                "id": "18814128",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810925",
                                                                                "variationId": "18814130"
                                                                            }
                                                                        ],
                                                                        "price": 46000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866563",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810925",
                                                                                "variationId": "18814129"
                                                                            }
                                                                        ],
                                                                        "price": 24500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866563",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810925",
                                                                                "variationId": "18814128"
                                                                            }
                                                                        ],
                                                                        "price": 14000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67840877",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67840857",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840890",
                                                                                "addonId": "54156429"
                                                                            },
                                                                            {
                                                                                "groupId": "67866563",
                                                                                "addonId": "54168863"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840877",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840857",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840890",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67866563",
                                                                    "groupName": "Bread",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54168863",
                                                                            "name": "Kuboos",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "393 ratings",
                                                                    "ratingCountV2": "393"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Mutton (Dry)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822574",
                                                            "name": "Mutton Pepper Dry",
                                                            "category": "Empire Special Mutton (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "tbbdp3koyjvnutggkual",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810856",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 630,
                                                                                "id": "18813940",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 330,
                                                                                "id": "18813939",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 185,
                                                                                "default": 1,
                                                                                "id": "18813938",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810856",
                                                                                "variationId": "18813940"
                                                                            }
                                                                        ],
                                                                        "price": 63000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810856",
                                                                                "variationId": "18813939"
                                                                            }
                                                                        ],
                                                                        "price": 33000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810856",
                                                                                "variationId": "18813938"
                                                                            }
                                                                        ],
                                                                        "price": 18500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837014",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837014",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 18500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "78 ratings",
                                                                    "ratingCountV2": "78"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822610",
                                                            "name": "Mutton Pepper Dry Boneless",
                                                            "category": "Empire Special Mutton (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "r31xfm9x08iok9q0d5qo",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810880",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 645,
                                                                                "id": "18814005",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 340,
                                                                                "id": "18814004",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 189,
                                                                                "default": 1,
                                                                                "id": "18814003",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810880",
                                                                                "variationId": "18814005"
                                                                            }
                                                                        ],
                                                                        "price": 64500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810880",
                                                                                "variationId": "18814004"
                                                                            }
                                                                        ],
                                                                        "price": 34000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810880",
                                                                                "variationId": "18814003"
                                                                            }
                                                                        ],
                                                                        "price": 18900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838112",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838112",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 18900,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "58 ratings",
                                                                    "ratingCountV2": "58"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822642",
                                                            "name": "Mutton Brain Dry Fry",
                                                            "category": "Empire Special Mutton (Dry)",
                                                            "description": "Serves 1",
                                                            "imageId": "yjktl5fctf4g4solnqcy",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810908",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 680,
                                                                                "id": "18814085",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 340,
                                                                                "id": "18814084",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 170,
                                                                                "default": 1,
                                                                                "id": "18814083",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810908",
                                                                                "variationId": "18814085"
                                                                            }
                                                                        ],
                                                                        "price": 68000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810908",
                                                                                "variationId": "18814084"
                                                                            }
                                                                        ],
                                                                        "price": 34000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810908",
                                                                                "variationId": "18814083"
                                                                            }
                                                                        ],
                                                                        "price": 17000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839876",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839876",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 17000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "273 ratings",
                                                                    "ratingCountV2": "273"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Rice",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215169",
                                                            "name": "Curd Rice",
                                                            "category": "Rice",
                                                            "description": "Serves 1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67844116",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67844149",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67844104",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67844096",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67844177",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "398 ratings",
                                                                    "ratingCountV2": "398"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215170",
                                                            "name": "Plain Rice",
                                                            "category": "Rice",
                                                            "description": "Serves 1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "28683763",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 70,
                                                                                "default": 1,
                                                                                "id": "90335373",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 70,
                                                                                "id": "90335374",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "28683763",
                                                                                "variationId": "90335373"
                                                                            }
                                                                        ],
                                                                        "price": 7000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "94507515",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "94507515",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "94507515",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "94507526",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "94507526",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "94507533",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "28683763",
                                                                                "variationId": "90335374"
                                                                            }
                                                                        ],
                                                                        "price": 7000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "94507504",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "94507511",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "94507515",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "94507515",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "94507515",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "94507526",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "94507526",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "94507533",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "94507542",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "94507504",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "94507511",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "94507515",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "94507526",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "94507533",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "94507542",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 7000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "343 ratings",
                                                                    "ratingCountV2": "343"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215166",
                                                            "name": "Ghee Rice",
                                                            "category": "Rice",
                                                            "description": "Serves 1",
                                                            "imageId": "troivpi2v0ybmdzwwz7l",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808629",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 101,
                                                                                "default": 1,
                                                                                "id": "77096199",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 101,
                                                                                "id": "77096200",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808629",
                                                                                "variationId": "77096199"
                                                                            }
                                                                        ],
                                                                        "price": 10100,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841713",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841713",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841713",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841710",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841710",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841749",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808629",
                                                                                "variationId": "77096200"
                                                                            }
                                                                        ],
                                                                        "price": 10100,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841722",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841735",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841713",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841713",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841713",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841710",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841710",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841749",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841754",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67841722",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841735",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841713",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841710",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841749",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841754",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 10100,
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "9131 ratings",
                                                                    "ratingCountV2": "9131"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215167",
                                                            "name": "Lemon Rice",
                                                            "category": "Rice",
                                                            "description": "Serves 1",
                                                            "imageId": "vgmmxxdnxv06pjgf3ksw",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808621",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 139,
                                                                                "default": 1,
                                                                                "id": "77096183",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 139,
                                                                                "id": "77096184",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808621",
                                                                                "variationId": "77096183"
                                                                            }
                                                                        ],
                                                                        "price": 13900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841593",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808621",
                                                                                "variationId": "77096184"
                                                                            }
                                                                        ],
                                                                        "price": 13900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841561",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841578",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841555",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841551",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841593",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841598",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67841561",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841578",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841555",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841551",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841593",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841598",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13900,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "309 ratings",
                                                                    "ratingCountV2": "309"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215168",
                                                            "name": "Jeera Rice",
                                                            "category": "Rice",
                                                            "description": "Serves 1",
                                                            "imageId": "vk0r9hgvonmw9zd4ymwp",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808622",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 139,
                                                                                "default": 1,
                                                                                "id": "77096185",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 139,
                                                                                "id": "77096186",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808622",
                                                                                "variationId": "77096185"
                                                                            }
                                                                        ],
                                                                        "price": 13900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841633",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841633",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841633",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841630",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841630",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841685",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808622",
                                                                                "variationId": "77096186"
                                                                            }
                                                                        ],
                                                                        "price": 13900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67841638",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67841668",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67841633",
                                                                                "addonId": "54156450"
                                                                            },
                                                                            {
                                                                                "groupId": "67841633",
                                                                                "addonId": "54156451"
                                                                            },
                                                                            {
                                                                                "groupId": "67841633",
                                                                                "addonId": "54156452"
                                                                            },
                                                                            {
                                                                                "groupId": "67841630",
                                                                                "addonId": "17505976"
                                                                            },
                                                                            {
                                                                                "groupId": "67841630",
                                                                                "addonId": "54156510"
                                                                            },
                                                                            {
                                                                                "groupId": "67841685",
                                                                                "addonId": "54156512"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67841688",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67841638",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841668",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841633",
                                                                    "groupName": "Salad",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156452",
                                                                            "name": "Green Salad",
                                                                            "price": 9500,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156451",
                                                                            "name": "Mini Salad",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156450",
                                                                            "name": "Pappad",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841630",
                                                                    "groupName": "Curd",
                                                                    "choices": [
                                                                        {
                                                                            "id": "17505976",
                                                                            "name": "Curd",
                                                                            "price": 4000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156510",
                                                                            "name": "Raitha",
                                                                            "price": 3500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 2,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841685",
                                                                    "groupName": "Dessert",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156512",
                                                                            "name": "Tender Coconut Pudding",
                                                                            "price": 7100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67841688",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13900,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "598 ratings",
                                                                    "ratingCountV2": "598"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Mutton (Gravy)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215135",
                                                            "name": "Pepper Mutton Masala",
                                                            "category": "Empire Special Mutton (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "smhvpyjoep9h1buvkpfl",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810910",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 627,
                                                                                "id": "18814091",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 322,
                                                                                "id": "18814090",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 170,
                                                                                "default": 1,
                                                                                "id": "18814089",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810910",
                                                                                "variationId": "18814091"
                                                                            }
                                                                        ],
                                                                        "price": 62700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923867",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810910",
                                                                                "variationId": "18814090"
                                                                            }
                                                                        ],
                                                                        "price": 32200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923867",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810910",
                                                                                "variationId": "18814089"
                                                                            }
                                                                        ],
                                                                        "price": 17000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923867",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839945",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839951",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839993",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923867",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839945",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839951",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839993",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 17000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "157 ratings",
                                                                    "ratingCountV2": "157"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215131",
                                                            "name": "Mutton Brain Masala",
                                                            "category": "Empire Special Mutton (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "adqdbgha4yupdvrd3lmx",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810785",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 693,
                                                                                "id": "18813741",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 346,
                                                                                "id": "18813740",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 173,
                                                                                "default": 1,
                                                                                "id": "18813739",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810785",
                                                                                "variationId": "18813741"
                                                                            }
                                                                        ],
                                                                        "price": 69300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923299",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810785",
                                                                                "variationId": "18813740"
                                                                            }
                                                                        ],
                                                                        "price": 34600,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923299",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810785",
                                                                                "variationId": "18813739"
                                                                            }
                                                                        ],
                                                                        "price": 17300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923299",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835203",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835208",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835217",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923299",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835203",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835208",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835217",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 17300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "100 ratings",
                                                                    "ratingCountV2": "100"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822482",
                                                            "name": "Mutton Kurma",
                                                            "category": "Empire Special Mutton (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "twjmxjokmjh7g0a7atwf",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810776",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 630,
                                                                                "id": "18813717",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 325,
                                                                                "id": "18813716",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 173,
                                                                                "default": 1,
                                                                                "id": "18813715",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810776",
                                                                                "variationId": "18813717"
                                                                            }
                                                                        ],
                                                                        "price": 63000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923273",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810776",
                                                                                "variationId": "18813716"
                                                                            }
                                                                        ],
                                                                        "price": 32500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923273",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810776",
                                                                                "variationId": "18813715"
                                                                            }
                                                                        ],
                                                                        "price": 17300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923273",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835059",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835061",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835065",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923273",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835059",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835061",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835065",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 17300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "47 ratings",
                                                                    "ratingCountV2": "47"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822549",
                                                            "name": "Mutton Varuval",
                                                            "category": "Empire Special Mutton (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "bmeksa4b6do9jkpxurz7",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810834",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 630,
                                                                                "id": "18813878",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 325,
                                                                                "id": "18813877",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 173,
                                                                                "default": 1,
                                                                                "id": "18813876",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810834",
                                                                                "variationId": "18813878"
                                                                            }
                                                                        ],
                                                                        "price": 63000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923517",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810834",
                                                                                "variationId": "18813877"
                                                                            }
                                                                        ],
                                                                        "price": 32500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923517",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810834",
                                                                                "variationId": "18813876"
                                                                            }
                                                                        ],
                                                                        "price": 17300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923517",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836280",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836282",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836302",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923517",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836280",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836282",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836302",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 17300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "74 ratings",
                                                                    "ratingCountV2": "74"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Chicken (Gravy)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822543",
                                                            "name": "Pepper Chicken Masala",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "flq53krkpkjkhod7zrwr",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810830",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 480,
                                                                                "id": "18813867",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813866",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18813865",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810830",
                                                                                "variationId": "18813867"
                                                                            }
                                                                        ],
                                                                        "price": 48000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923504",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810830",
                                                                                "variationId": "18813866"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923504",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810830",
                                                                                "variationId": "18813865"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923504",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836082",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836087",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836094",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923504",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836082",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836087",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836094",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "181 ratings",
                                                                    "ratingCountV2": "181"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215100",
                                                            "name": "Chicken Manchurian Masala",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "ks5nvn1d9ufzq7bxifvu",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810913",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18814099",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 265,
                                                                                "id": "18814098",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 153,
                                                                                "default": 1,
                                                                                "id": "18814097",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810913",
                                                                                "variationId": "18814099"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923885",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810913",
                                                                                "variationId": "18814098"
                                                                            }
                                                                        ],
                                                                        "price": 26500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923885",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810913",
                                                                                "variationId": "18814097"
                                                                            }
                                                                        ],
                                                                        "price": 15300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923885",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840048",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840057",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840080",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923885",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840048",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840057",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840080",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.3",
                                                                    "ratingCount": "100 ratings",
                                                                    "ratingCountV2": "100"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215108",
                                                            "name": "Chicken Masala",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "jnd6i6omxpfa3nosk8zy",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810791",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 484,
                                                                                "id": "18813757",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813756",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18813755",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810791",
                                                                                "variationId": "18813757"
                                                                            }
                                                                        ],
                                                                        "price": 48400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923309",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810791",
                                                                                "variationId": "18813756"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923309",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810791",
                                                                                "variationId": "18813755"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923309",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835406",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835411",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835429",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923309",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835406",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835411",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835429",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.6",
                                                                    "ratingCount": "305 ratings",
                                                                    "ratingCountV2": "305"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215110",
                                                            "name": "Chicken Tikka Masala",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "icpycagtwmqflonmjud8",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810906",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 515,
                                                                                "id": "18814079",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 273,
                                                                                "id": "18814078",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 153,
                                                                                "default": 1,
                                                                                "id": "18814077",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810906",
                                                                                "variationId": "18814079"
                                                                            }
                                                                        ],
                                                                        "price": 51500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923857",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810906",
                                                                                "variationId": "18814078"
                                                                            }
                                                                        ],
                                                                        "price": 27300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923857",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810906",
                                                                                "variationId": "18814077"
                                                                            }
                                                                        ],
                                                                        "price": 15300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923857",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67839762",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839769",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839808",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923857",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839762",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839769",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839808",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "1070 ratings",
                                                                    "ratingCountV2": "1070"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215111",
                                                            "name": "Chicken Tandoori Masala",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "l9jc37cdfdc0nnpk49ln",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810917",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 510,
                                                                                "id": "18814109",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 275,
                                                                                "id": "18814108",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 158,
                                                                                "default": 1,
                                                                                "id": "18814107",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810917",
                                                                                "variationId": "18814109"
                                                                            }
                                                                        ],
                                                                        "price": 51000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923893",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810917",
                                                                                "variationId": "18814108"
                                                                            }
                                                                        ],
                                                                        "price": 27500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923893",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810917",
                                                                                "variationId": "18814107"
                                                                            }
                                                                        ],
                                                                        "price": 15800,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923893",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840315",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840319",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840339",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923893",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840315",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840319",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840339",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15800,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "276 ratings",
                                                                    "ratingCountV2": "276"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822498",
                                                            "name": "Chicken Kurma",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810793",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 490,
                                                                                "id": "18813762",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813761",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18813760",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810793",
                                                                                "variationId": "18813762"
                                                                            }
                                                                        ],
                                                                        "price": 49000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923345",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810793",
                                                                                "variationId": "18813761"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923345",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810793",
                                                                                "variationId": "18813760"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923345",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835486",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835488",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835511",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923345",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835486",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835488",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835511",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "51 ratings",
                                                                    "ratingCountV2": "51"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822535",
                                                            "name": "Butter Chicken",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "kywkfwwyqscindrzh1fa",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810825",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 484,
                                                                                "id": "18813854",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18813853",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18813852",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810825",
                                                                                "variationId": "18813854"
                                                                            }
                                                                        ],
                                                                        "price": 48400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923482",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810825",
                                                                                "variationId": "18813853"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923482",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810825",
                                                                                "variationId": "18813852"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923482",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836035",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836041",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836052",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923482",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836035",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836041",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836052",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "486 ratings",
                                                                    "ratingCountV2": "486"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822601",
                                                            "name": "Butter Chicken Boneless",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "vbtgihmcmseeizl1iuma",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810875",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18813991",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 265,
                                                                                "id": "18813990",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 153,
                                                                                "default": 1,
                                                                                "id": "18813989",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810875",
                                                                                "variationId": "18813991"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923621",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810875",
                                                                                "variationId": "18813990"
                                                                            }
                                                                        ],
                                                                        "price": 26500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923621",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810875",
                                                                                "variationId": "18813989"
                                                                            }
                                                                        ],
                                                                        "price": 15300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923621",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67837898",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837909",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837929",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923621",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837898",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837909",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837929",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "949 ratings",
                                                                    "ratingCountV2": "949"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822617",
                                                            "name": "Chicken Varval",
                                                            "category": "Empire Special Chicken (Gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "mk3acltmonkzutknsqny",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810887",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 480,
                                                                                "id": "18814025",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "18814024",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18814023",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810887",
                                                                                "variationId": "18814025"
                                                                            }
                                                                        ],
                                                                        "price": 48000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923663",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810887",
                                                                                "variationId": "18814024"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923663",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810887",
                                                                                "variationId": "18814023"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923663",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838418",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838427",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838446",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923663",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838418",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838427",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838446",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "258 ratings",
                                                                    "ratingCountV2": "258"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Parottas",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215180",
                                                            "name": "Dry Chapati",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "vujildtrdyn6temnxvio",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808602",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 30,
                                                                                "default": 1,
                                                                                "id": "77096145",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 30,
                                                                                "id": "77096146",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808602",
                                                                                "variationId": "77096145"
                                                                            }
                                                                        ],
                                                                        "price": 3000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808602",
                                                                                "variationId": "77096146"
                                                                            }
                                                                        ],
                                                                        "price": 3000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838969",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838986",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838998",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838969",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838986",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838998",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "691 ratings",
                                                                    "ratingCountV2": "691"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822584",
                                                            "name": "Egg Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "fdreyhmkuy5uqcsp4yj4",
                                                            "inStock": 1,
                                                            "price": 9100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837329",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837341",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837355",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "75 ratings",
                                                                    "ratingCountV2": "75"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215184",
                                                            "name": "Kerala Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "pwgx9hyprqwfn7nzbxew",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808588",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 37,
                                                                                "default": 1,
                                                                                "id": "77096117",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 37,
                                                                                "id": "77096118",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808588",
                                                                                "variationId": "77096117"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808588",
                                                                                "variationId": "77096118"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837727",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837773",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837789",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837727",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837773",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837789",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "1985 ratings",
                                                                    "ratingCountV2": "1985"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215185",
                                                            "name": "Malabar Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "ldyhzva56ancpx51vbcl",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808559",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 31,
                                                                                "default": 1,
                                                                                "id": "77096061",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 31,
                                                                                "id": "77096062",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808559",
                                                                                "variationId": "77096061"
                                                                            }
                                                                        ],
                                                                        "price": 3100,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808559",
                                                                                "variationId": "77096062"
                                                                            }
                                                                        ],
                                                                        "price": 3100,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67835746",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67835767",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67835775",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835746",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835767",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835775",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3100,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "2884 ratings",
                                                                    "ratingCountV2": "2884"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215186",
                                                            "name": "Ceylon Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "ediibdf3gsujqd6ifutq",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808578",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 37,
                                                                                "default": 1,
                                                                                "id": "77096099",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 37,
                                                                                "id": "77096100",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808578",
                                                                                "variationId": "77096099"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808578",
                                                                                "variationId": "77096100"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836362",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67836368",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836374",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836362",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836368",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836374",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "1017 ratings",
                                                                    "ratingCountV2": "1017"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215187",
                                                            "name": "Coin Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "fmfupmuieyd62gfdcddh",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808597",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 30,
                                                                                "default": 1,
                                                                                "id": "77096135",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 30,
                                                                                "id": "77096136",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808597",
                                                                                "variationId": "77096135"
                                                                            }
                                                                        ],
                                                                        "price": 3000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808597",
                                                                                "variationId": "77096136"
                                                                            }
                                                                        ],
                                                                        "price": 3000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838789",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838811",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838789",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838811",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838847",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "1804 ratings",
                                                                    "ratingCountV2": "1804"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215188",
                                                            "name": "Wheat Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "pcazjlp7ayhpfx6utrfs",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808587",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 37,
                                                                                "default": 1,
                                                                                "id": "77096115",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 37,
                                                                                "id": "77096116",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808587",
                                                                                "variationId": "77096115"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808587",
                                                                                "variationId": "77096116"
                                                                            }
                                                                        ],
                                                                        "price": 3700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837637",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837672",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837698",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837637",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837672",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837698",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "826 ratings",
                                                                    "ratingCountV2": "826"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215190",
                                                            "name": "Onion Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "myyuewcas7lpkmujnznr",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 6100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.3",
                                                                    "ratingCount": "47 ratings",
                                                                    "ratingCountV2": "47"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215192",
                                                            "name": "Empire Butter Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "alnvnbfhdf1zaw3js35b",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808592",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 46,
                                                                                "default": 1,
                                                                                "id": "77096125",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 46,
                                                                                "id": "77096126",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808592",
                                                                                "variationId": "77096125"
                                                                            }
                                                                        ],
                                                                        "price": 4600,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808592",
                                                                                "variationId": "77096126"
                                                                            }
                                                                        ],
                                                                        "price": 4600,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838131",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838144",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838152",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838131",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838144",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838152",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 4600,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "65 ratings",
                                                                    "ratingCountV2": "65"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822589",
                                                            "name": "Ghee Chapathi",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "qsdkgx5pnq02wplrjoet",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808585",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 33,
                                                                                "default": 1,
                                                                                "id": "77096111",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 33,
                                                                                "id": "77096112",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808585",
                                                                                "variationId": "77096111"
                                                                            }
                                                                        ],
                                                                        "price": 3300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808585",
                                                                                "variationId": "77096112"
                                                                            }
                                                                        ],
                                                                        "price": 3300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837531",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837547",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837556",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837531",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837547",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837556",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "86 ratings",
                                                                    "ratingCountV2": "86"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822629",
                                                            "name": "Empire Mix Parotta",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "obn7o07vyyjjeqwifnsd",
                                                            "inStock": 1,
                                                            "price": 19000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839129",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839139",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839151",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "36 ratings",
                                                                    "ratingCountV2": "36"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822632",
                                                            "name": "Empire Special Porota",
                                                            "category": "Parottas",
                                                            "description": "Serves 1",
                                                            "imageId": "bvctwoc4xuwlpwwe1bif",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "23808606",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 50,
                                                                                "default": 1,
                                                                                "id": "77096153",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 50,
                                                                                "id": "77096154",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808606",
                                                                                "variationId": "77096153"
                                                                            }
                                                                        ],
                                                                        "price": 5000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "23808606",
                                                                                "variationId": "77096154"
                                                                            }
                                                                        ],
                                                                        "price": 5000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839504",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839520",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839535",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839504",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839520",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839535",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 5000,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "178 ratings",
                                                                    "ratingCountV2": "178"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Rotis",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215171",
                                                            "name": "Tandoori Roti",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "w3yfetb1zmaa7yawvmbg",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 3200,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837261",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837273",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837281",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "810 ratings",
                                                                    "ratingCountV2": "810"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215173",
                                                            "name": "Butter Roti",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "svkp2zkf11nyaz7w6vs1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 3600,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836402",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836415",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836422",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.7",
                                                                    "ratingCount": "281 ratings",
                                                                    "ratingCountV2": "281"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215175",
                                                            "name": "Kulcha",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "bzdjx3rqgccz6iuyyk0b",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "24090406",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 35,
                                                                                "default": 1,
                                                                                "id": "77727447",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 35,
                                                                                "id": "77727448",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090406",
                                                                                "variationId": "77727447"
                                                                            }
                                                                        ],
                                                                        "price": 3500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090406",
                                                                                "variationId": "77727448"
                                                                            }
                                                                        ],
                                                                        "price": 3500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839052",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839089",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839103",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839052",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839089",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839103",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "1067 ratings",
                                                                    "ratingCountV2": "1067"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215176",
                                                            "name": "Tandoori Naan",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "mq1wvypya46dahpmedir",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "24090400",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 35,
                                                                                "default": 1,
                                                                                "id": "77727435",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 35,
                                                                                "id": "77727436",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090400",
                                                                                "variationId": "77727435"
                                                                            }
                                                                        ],
                                                                        "price": 3500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090400",
                                                                                "variationId": "77727436"
                                                                            }
                                                                        ],
                                                                        "price": 3500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838177",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838207",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838216",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838177",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838207",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838216",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 3500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "365 ratings",
                                                                    "ratingCountV2": "365"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215177",
                                                            "name": "Butter Naan",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "kpzbzfamrpnqune4nxn6",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "24090407",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 45,
                                                                                "default": 1,
                                                                                "id": "77727449",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 45,
                                                                                "id": "77727450",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090407",
                                                                                "variationId": "77727449"
                                                                            }
                                                                        ],
                                                                        "price": 4500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090407",
                                                                                "variationId": "77727450"
                                                                            }
                                                                        ],
                                                                        "price": 4500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67839310",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67839343",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839371",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839310",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839343",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839371",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 4500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "1149 ratings",
                                                                    "ratingCountV2": "1149"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "1395450",
                                                            "name": "Butter Kulcha",
                                                            "category": "Rotis",
                                                            "description": "Serves 1",
                                                            "imageId": "thbj92jjhbmctknwaqnh",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "24090387",
                                                                        "name": "Complementary",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Complementary Dal",
                                                                                "price": 45,
                                                                                "default": 1,
                                                                                "id": "77727410",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Complementary Red Gravy",
                                                                                "price": 45,
                                                                                "id": "77727411",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090387",
                                                                                "variationId": "77727410"
                                                                            }
                                                                        ],
                                                                        "price": 4500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "24090387",
                                                                                "variationId": "77727411"
                                                                            }
                                                                        ],
                                                                        "price": 4500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67837159",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837167",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837185",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837159",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837167",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837185",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 4500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "157 ratings",
                                                                    "ratingCountV2": "157"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "North Indian Veg (gravy)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "79335727",
                                                            "name": "Tawa Paneer",
                                                            "category": "North Indian Veg (gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "nlfkcvfulkz0iionu9om",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20300,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67842693",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842717",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842746",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "19 ratings",
                                                                    "ratingCountV2": "19"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "79335728",
                                                            "name": "Tawa Veg",
                                                            "category": "North Indian Veg (gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "k1bsgnny2kert0wxj8ab",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20300,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67842770",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842776",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67842802",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.8",
                                                                    "ratingCount": "7 ratings",
                                                                    "ratingCountV2": "7"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822560",
                                                            "name": "Kadai Veg",
                                                            "category": "North Indian Veg (gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "s3wwjyfhrp5fgcmajdjr",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13800,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923548",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836618",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836629",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836637",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "50 ratings",
                                                                    "ratingCountV2": "50"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822622",
                                                            "name": "Kadai Paneer",
                                                            "category": "North Indian Veg (gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "bxxarwcannwouaouy3os",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810893",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 240,
                                                                                "id": "18814042",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 133,
                                                                                "default": 1,
                                                                                "id": "18814041",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810893",
                                                                                "variationId": "18814042"
                                                                            }
                                                                        ],
                                                                        "price": 24000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923684",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838548",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838548",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838548",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810893",
                                                                                "variationId": "18814041"
                                                                            }
                                                                        ],
                                                                        "price": 13300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923684",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838548",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838548",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838548",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838552",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838573",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923684",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838548",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838552",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838573",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 13300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "105 ratings",
                                                                    "ratingCountV2": "105"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Desserts",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "83973556",
                                                            "name": "Tender Coconut Pudding",
                                                            "category": "Desserts",
                                                            "description": "Serves 1 | A refreshing delight with delicate flavors made from tender coconut, all set to melt in your mouth.(100gms)",
                                                            "imageId": "kfjnsxwv02iiquqaykvc",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67842866",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "357 ratings",
                                                                    "ratingCountV2": "357"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Egg Item",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822495",
                                                            "name": "Egg Burji",
                                                            "category": "Egg Item",
                                                            "description": "Serves 1",
                                                            "imageId": "cg5s6kzlpaunkh8fplua",
                                                            "inStock": 1,
                                                            "price": 8200,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "88 ratings",
                                                                    "ratingCountV2": "88"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822484",
                                                            "name": "Egg Bulls Eye",
                                                            "category": "Egg Item",
                                                            "description": "Serves 1",
                                                            "imageId": "fryhh8spfxlbiwtamjgp",
                                                            "inStock": 1,
                                                            "price": 5100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.8",
                                                                    "ratingCount": "28 ratings",
                                                                    "ratingCountV2": "28"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822497",
                                                            "name": "Spl Dal Fry With Egg",
                                                            "category": "Egg Item",
                                                            "description": "Serves 1",
                                                            "imageId": "auuwpssammnfjaocpuam",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810792",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 258,
                                                                                "id": "18813759",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "18813758",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810792",
                                                                                "variationId": "18813759"
                                                                            }
                                                                        ],
                                                                        "price": 25800,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923338",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835471",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835471",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835471",
                                                                                "addonId": "54156418"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810792",
                                                                                "variationId": "18813758"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923338",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67835471",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67835471",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67835471",
                                                                                "addonId": "54156418"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923338",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835471",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.4",
                                                                    "ratingCount": "37 ratings",
                                                                    "ratingCountV2": "37"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215092",
                                                            "name": "Egg Omelette",
                                                            "category": "Egg Item",
                                                            "description": "Serves 1",
                                                            "imageId": "mkh1a6yrfor6cqvr1tua",
                                                            "inStock": 1,
                                                            "price": 8200,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "121 ratings",
                                                                    "ratingCountV2": "121"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822649",
                                                            "name": "Boiled Egg (2 Nos)",
                                                            "category": "Egg Item",
                                                            "description": "Serves 1",
                                                            "imageId": "ruywk7pf1yvmzeb9jnv3",
                                                            "inStock": 1,
                                                            "price": 4100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840216",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.9",
                                                                    "ratingCount": "32 ratings",
                                                                    "ratingCountV2": "32"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Empire Special Tawa Dishes",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822506",
                                                            "name": "Fiery Basa Fish Fillet",
                                                            "category": "Empire Special Tawa Dishes",
                                                            "description": "Serves 1",
                                                            "imageId": "cmbtminwmsomjsaxmad4",
                                                            "inStock": 1,
                                                            "price": 35500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835720",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835726",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "49 ratings",
                                                                    "ratingCountV2": "49"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822533",
                                                            "name": "Hot Chilly Prawns (tawa Fry)",
                                                            "category": "Empire Special Tawa Dishes",
                                                            "description": "Serves 1",
                                                            "imageId": "w0ryzceyck4utca3l9pf",
                                                            "inStock": 1,
                                                            "price": 36200,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835979",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835986",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.6",
                                                                    "ratingCount": "66 ratings",
                                                                    "ratingCountV2": "66"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822635",
                                                            "name": "Fiery Chicken Wings",
                                                            "category": "Empire Special Tawa Dishes",
                                                            "description": "Serves 1",
                                                            "imageId": "pw9oczdrdjeeos8zxwn2",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810904",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18814073",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 270,
                                                                                "id": "18814072",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 145,
                                                                                "default": 1,
                                                                                "id": "28135464",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810904",
                                                                                "variationId": "18814073"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810904",
                                                                                "variationId": "18814072"
                                                                            }
                                                                        ],
                                                                        "price": 27000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810904",
                                                                                "variationId": "28135464"
                                                                            }
                                                                        ],
                                                                        "price": 14500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156436"
                                                                            },
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156437"
                                                                            },
                                                                            {
                                                                                "groupId": "67839669",
                                                                                "addonId": "54156438"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67839674",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839669",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839674",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14500,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "297 ratings",
                                                                    "ratingCountV2": "297"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Fried Rice & Noodles",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215228",
                                                            "name": "Prawns Fried Rice",
                                                            "category": "Fried Rice & Noodles",
                                                            "description": "Serves 1",
                                                            "imageId": "csop6sf3zuvis19txy7q",
                                                            "inStock": 1,
                                                            "price": 24500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840628",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840658",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "64 ratings",
                                                                    "ratingCountV2": "64"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215224",
                                                            "name": "Egg Fried Rice",
                                                            "category": "Fried Rice & Noodles",
                                                            "description": "Serves 1",
                                                            "imageId": "vretzm7ieccmpf28g4oh",
                                                            "inStock": 1,
                                                            "price": 19400,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838357",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838381",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "418 ratings",
                                                                    "ratingCountV2": "418"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215223",
                                                            "name": "Veg Fried Rice",
                                                            "category": "Fried Rice & Noodles",
                                                            "description": "Serves 1",
                                                            "imageId": "vvpigujlw9jyfbtt2xxa",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18400,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836131",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836150",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "386 ratings",
                                                                    "ratingCountV2": "386"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215225",
                                                            "name": "Chicken Fried Rice",
                                                            "category": "Fried Rice & Noodles",
                                                            "description": "Serves 1",
                                                            "imageId": "pkoi9cfitwisdevisr7v",
                                                            "inStock": 1,
                                                            "price": 21400,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840112",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840153",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "742 ratings",
                                                                    "ratingCountV2": "742"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215226",
                                                            "name": "Mutton Fried Rice",
                                                            "category": "Fried Rice & Noodles",
                                                            "description": "Serves 1",
                                                            "imageId": "uocn0xa0orusb0hitvqw",
                                                            "inStock": 1,
                                                            "price": 24500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835071",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835074",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "65 ratings",
                                                                    "ratingCountV2": "65"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822651",
                                                            "name": "Mix Fried Rice Non Veg",
                                                            "category": "Fried Rice & Noodles",
                                                            "description": "Serves 1",
                                                            "imageId": "nhyk8elhcalzcdybca75",
                                                            "inStock": 1,
                                                            "price": 23500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840241",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840275",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.7",
                                                                    "ratingCount": "38 ratings",
                                                                    "ratingCountV2": "38"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Shawarma",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822681",
                                                            "name": "Tawa Shawarma",
                                                            "category": "Shawarma",
                                                            "description": "Serves 1",
                                                            "imageId": "lknei9tpqykfvudty8ax",
                                                            "inStock": 1,
                                                            "price": 16200,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "72802152",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "1184 ratings",
                                                                    "ratingCountV2": "1184"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "1794387",
                                                            "name": "Chicken Shawarma",
                                                            "category": "Shawarma",
                                                            "description": "Serves 1",
                                                            "imageId": "fbtsm6ejxytccvjbjf4l",
                                                            "inStock": 1,
                                                            "price": 9000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839459",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839468",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "4582 ratings",
                                                                    "ratingCountV2": "4582"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "North Indian Non Veg (gravy)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215113",
                                                            "name": "Kadai Chicken Gravy",
                                                            "category": "North Indian Non Veg (gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "sw1jachllyur2m1eew2c",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "9996806",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 490,
                                                                                "id": "33010918",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 255,
                                                                                "id": "33010919",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 143,
                                                                                "default": 1,
                                                                                "id": "33010920",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "9996806",
                                                                                "variationId": "33010918"
                                                                            }
                                                                        ],
                                                                        "price": 49000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923698",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "9996806",
                                                                                "variationId": "33010919"
                                                                            }
                                                                        ],
                                                                        "price": 25500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923698",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "9996806",
                                                                                "variationId": "33010920"
                                                                            }
                                                                        ],
                                                                        "price": 14300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923698",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838631",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838645",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838678",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923698",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838631",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838645",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838678",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 14300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.6",
                                                                    "ratingCount": "271 ratings",
                                                                    "ratingCountV2": "271"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822621",
                                                            "name": "Hyderabadi Chicken Boneless Gravy",
                                                            "category": "North Indian Non Veg (gravy)",
                                                            "description": "Serves 1",
                                                            "imageId": "vjzytwcf9qrj6mjqm0hh",
                                                            "inStock": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810891",
                                                                        "name": "Portion",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 500,
                                                                                "id": "18814037",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 265,
                                                                                "id": "18814036",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 153,
                                                                                "default": 1,
                                                                                "id": "18814035",
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810891",
                                                                                "variationId": "18814037"
                                                                            }
                                                                        ],
                                                                        "price": 50000,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923672",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810891",
                                                                                "variationId": "18814036"
                                                                            }
                                                                        ],
                                                                        "price": 26500,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923672",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810891",
                                                                                "variationId": "18814035"
                                                                            }
                                                                        ],
                                                                        "price": 15300,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923672",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838478",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838496",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838519",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923672",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838478",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838496",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838519",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 15300,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "55 ratings",
                                                                    "ratingCountV2": "55"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Salads",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117673923",
                                                            "name": "Mini Salad",
                                                            "category": "Salads",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 3500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Soup",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215004",
                                                            "name": "Chicken Clear Soup",
                                                            "category": "Soup",
                                                            "inStock": 1,
                                                            "price": 9100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840602",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "183 ratings",
                                                                    "ratingCountV2": "183"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "24685892",
                                                            "name": "Lemon Coriander Chicken Soup",
                                                            "category": "Soup",
                                                            "inStock": 1,
                                                            "price": 9100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837574",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.2",
                                                                    "ratingCount": "86 ratings",
                                                                    "ratingCountV2": "86"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Veg Dry",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822592",
                                                            "name": "Pappad",
                                                            "category": "Veg Dry",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 2000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "50 ratings",
                                                                    "ratingCountV2": "50"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215007",
                                                            "name": "Gobi Manchurian",
                                                            "category": "Veg Dry",
                                                            "description": "Serves 1",
                                                            "imageId": "rsis0nq4bvjiu2g7ncks",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810882",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 174,
                                                                                "id": "18814010",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 97,
                                                                                "default": 1,
                                                                                "id": "18814009",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810882",
                                                                                "variationId": "18814010"
                                                                            }
                                                                        ],
                                                                        "price": 17400,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810882",
                                                                                "variationId": "18814009"
                                                                            }
                                                                        ],
                                                                        "price": 9700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67838240",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838247",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67838240",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838247",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 9700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "977 ratings",
                                                                    "ratingCountV2": "977"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822582",
                                                            "name": "Paneer Chilly Dry",
                                                            "category": "Veg Dry",
                                                            "description": "Serves 1",
                                                            "imageId": "j1kkkv5uzgtbtgnwexkr",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810862",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 179,
                                                                                "id": "18813956",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 102,
                                                                                "default": 1,
                                                                                "id": "18813955",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810862",
                                                                                "variationId": "18813956"
                                                                            }
                                                                        ],
                                                                        "price": 17900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810862",
                                                                                "variationId": "18813955"
                                                                            }
                                                                        ],
                                                                        "price": 10200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156457"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156458"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156459"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156460"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156461"
                                                                            },
                                                                            {
                                                                                "groupId": "67837200",
                                                                                "addonId": "54156462"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67837210",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "67837200",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67837210",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 10200,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "112 ratings",
                                                                    "ratingCountV2": "112"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Veg Gravy",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822563",
                                                            "name": "Raitha",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "imageId": "pxfpgtc5od4wnvqtqlgk",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 3500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836658",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836663",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836673",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.8",
                                                                    "ratingCount": "28 ratings",
                                                                    "ratingCountV2": "28"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822661",
                                                            "name": "Dal Tadka",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810926",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Full",
                                                                                "price": 237,
                                                                                "id": "18814133",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 128,
                                                                                "id": "18814132",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 77,
                                                                                "default": 1,
                                                                                "id": "18814131",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810926",
                                                                                "variationId": "18814133"
                                                                            }
                                                                        ],
                                                                        "price": 23700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923954",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810926",
                                                                                "variationId": "18814132"
                                                                            }
                                                                        ],
                                                                        "price": 12800,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923954",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810926",
                                                                                "variationId": "18814131"
                                                                            }
                                                                        ],
                                                                        "price": 7700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923954",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67840942",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67840950",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67840979",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923954",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840942",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840950",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840979",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 7700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "119 ratings",
                                                                    "ratingCountV2": "119"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215089",
                                                            "name": "Dal Fry",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "imageId": "jxxtujwekfghedg6axk1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810896",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 122,
                                                                                "id": "18814050",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 71,
                                                                                "default": 1,
                                                                                "id": "18814049",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810896",
                                                                                "variationId": "18814050"
                                                                            }
                                                                        ],
                                                                        "price": 12200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923715",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810896",
                                                                                "variationId": "18814049"
                                                                            }
                                                                        ],
                                                                        "price": 7100,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923715",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67838709",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67838720",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67838750",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923715",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838709",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838720",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67838750",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 7100,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "1319 ratings",
                                                                    "ratingCountV2": "1319"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215084",
                                                            "name": "Paneer Butter Masala",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "imageId": "aebk3ggsozr3gtijronv",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810851",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 189,
                                                                                "id": "18813925",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 112,
                                                                                "default": 1,
                                                                                "id": "18813924",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810851",
                                                                                "variationId": "18813925"
                                                                            }
                                                                        ],
                                                                        "price": 18900,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923559",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810851",
                                                                                "variationId": "18813924"
                                                                            }
                                                                        ],
                                                                        "price": 11200,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68923559",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836806",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836836",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836847",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68923559",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836806",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836836",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836847",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 11200,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "2157 ratings",
                                                                    "ratingCountV2": "2157"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822555",
                                                            "name": "Veg Kurma",
                                                            "category": "Veg Gravy",
                                                            "description": "Serves 1",
                                                            "imageId": "aabyscimg5b0yyf4k4yu",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "variants": {},
                                                            "variantsV2": {
                                                                "variantGroups": [
                                                                    {
                                                                        "groupId": "5810837",
                                                                        "name": "Portion ",
                                                                        "variations": [
                                                                            {
                                                                                "name": "Half",
                                                                                "price": 148,
                                                                                "id": "18813886",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "name": "Qtr",
                                                                                "price": 87,
                                                                                "default": 1,
                                                                                "id": "18813885",
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "pricingModels": [
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810837",
                                                                                "variationId": "18813886"
                                                                            }
                                                                        ],
                                                                        "price": 14800,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68924583",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836466",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836466",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836466",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "variations": [
                                                                            {
                                                                                "groupId": "5810837",
                                                                                "variationId": "18813885"
                                                                            }
                                                                        ],
                                                                        "price": 8700,
                                                                        "addonCombinations": [
                                                                            {
                                                                                "groupId": "68924583",
                                                                                "addonId": "54935012"
                                                                            },
                                                                            {
                                                                                "groupId": "67836466",
                                                                                "addonId": "54156416"
                                                                            },
                                                                            {
                                                                                "groupId": "67836466",
                                                                                "addonId": "54156417"
                                                                            },
                                                                            {
                                                                                "groupId": "67836466",
                                                                                "addonId": "54156418"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156419"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156420"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156421"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156422"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156423"
                                                                            },
                                                                            {
                                                                                "groupId": "67836496",
                                                                                "addonId": "54156424"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156425"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156426"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156427"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156428"
                                                                            },
                                                                            {
                                                                                "groupId": "67836512",
                                                                                "addonId": "54156429"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "addons": [
                                                                {
                                                                    "groupId": "68924583",
                                                                    "groupName": "Rice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54935012",
                                                                            "name": "Ghee Rice",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836466",
                                                                    "groupName": "Parotta",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156417",
                                                                            "name": "Empire Spl Parotta",
                                                                            "price": 4700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156416",
                                                                            "name": "Coin Paroatta",
                                                                            "price": 2700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156418",
                                                                            "name": "Kerala Parotta",
                                                                            "price": 3600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836496",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836512",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "defaultPrice": 8700,
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.1",
                                                                    "ratingCount": "44 ratings",
                                                                    "ratingCountV2": "44"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            "title": "Juice Shop",
                                            "categories": [
                                                {
                                                    "title": "Lychee Fest",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "120688145",
                                                                    "name": "Lychee\xa0Malba",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 14300,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "120688146",
                                                                    "name": "Lychee Thickshake",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 13200,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "120688147",
                                                                    "name": "Lychee Falooda",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 19800,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "120688148",
                                                                    "name": "Lady Lychee",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 9900,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Falooda",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519299",
                                                                    "name": "Empire Special Falooda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | This Signature Falooda is made with fresh cut pieces of Kiwi and Bananas mixed together with our special homemade rose milk mixture and a combination of jelly, poppy seeds, vermicelli, cereals and dry fruit mixture that is all topped off with rainbow ice cream and red cherry.",
                                                                    "imageId": "ogahlaofpbpzwrcot0n6",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 19800,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.7",
                                                                            "ratingCount": "22 ratings",
                                                                            "ratingCountV2": "22"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519302",
                                                                    "name": "Tender Coconut Falooda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | For those with a sweet tooth, the Tender Falooda Ice Cream is a delicious treat. This traditional dessert is made with tender coconut flavors combined with layers of jelly, poppy seeds, vermicelli, dry fruit mixture, and topped with red cherry.",
                                                                    "imageId": "ccfzjuihtwly6azwyvyo",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 18700,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.8",
                                                                            "ratingCount": "15 ratings",
                                                                            "ratingCountV2": "15"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28308865",
                                                                    "name": "Bombay Falooda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | This Falooda is our interpretation of the classical Bombay style Falooda. Made from special homemade rose milk mix combined with layers of jelly, poppy seeds, vermicelli, dry fruit mixture, and topped with red cherry.",
                                                                    "imageId": "r6rf3osd6glvxzj7p0d7",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 15400,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.5",
                                                                            "ratingCount": "193 ratings",
                                                                            "ratingCountV2": "193"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309643",
                                                                    "name": "Kulfi Falooda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Treat yourself to a little indulgence with our Kulfi Ice Cream Falooda. Topped with Rich Malai Kulfi Ice Cream combined with layers of jelly, poppy seeds, vermicelli and dry fruit mixture, . It's the perfect end to any meal.",
                                                                    "imageId": "ehwvo8dhazsxoslkfb9s",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 15400,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.0",
                                                                            "ratingCount": "144 ratings",
                                                                            "ratingCountV2": "144"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309677",
                                                                    "name": "Rabdi Falooda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Rabdi Falooda Ice Cream is an enticing and mouthwatering dessert. It has a delicious taste that is simply appetizing. This dessert is prepared using homemade rabadi, poppy seeds, vermicelli, ice cream, dry fruit mixture topped with red cherry.",
                                                                    "imageId": "lbdoyqirtmggsxfag7z5",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 15400,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.2",
                                                                            "ratingCount": "149 ratings",
                                                                            "ratingCountV2": "149"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Chocolate Fest",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "104035812",
                                                                    "name": "Chocolate Mousse",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "rkufmtlhzq2ufiuqs5on",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 7500,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.3",
                                                                            "ratingCount": "5 ratings",
                                                                            "ratingCountV2": "5"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "104035813",
                                                                    "name": "Hot Chocolate Fudge",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "l6sxj0dmltdp1yaoeaym",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 14500,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.8",
                                                                            "ratingCount": "5 ratings",
                                                                            "ratingCountV2": "5"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309444",
                                                                    "name": "Death By Chocolate",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | DBC is everyone\u2019s favourite. Scoops of rich and creamy vanilla ice cream with of a warm homemade chocolate cake sponge, drizzled with our signature homemade DBC sauce and roasted peanuts is an absolute treat for every dessert lover.",
                                                                    "imageId": "lvhxynldslndyn4u02ma",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 16500,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.1",
                                                                            "ratingCount": "42 ratings",
                                                                            "ratingCountV2": "42"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Desserts & Sundaes",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519416",
                                                                    "name": "Mudpot",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Indulge your sweet tooth with this heavenly dessert. It's made of vanilla custard with bits of chocolate cake sponge, chocolate sauce, dry fruits and topped with rich and creamy scoop of vanilla ice cream.",
                                                                    "imageId": "irvle0rfgkcsnjrzaykf",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 14300,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.5",
                                                                            "ratingCount": "5 ratings",
                                                                            "ratingCountV2": "5"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519419",
                                                                    "name": "Red Velvet Pot",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | A melt in mouth Red Velvet Pot made with red velvet cake sponge, a layer of luscious fruit custard topped with scoop of strawberry ice cream.",
                                                                    "imageId": "zwkm2liumpaxeo73unz6",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 14300,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "2.5",
                                                                            "ratingCount": "3 ratings",
                                                                            "ratingCountV2": "3"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519441",
                                                                    "name": "Fruit Custard",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | A delightful change in your regular fruit salad. Made with the freshest seasonal fruits and crowned with layers vanilla and strawberry custard.",
                                                                    "imageId": "x2nmqlzuckjqdvqpjjx2",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 10450,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.6",
                                                                            "ratingCount": "20 ratings",
                                                                            "ratingCountV2": "20"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309455",
                                                                    "name": "Banoffee Sundae",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Sweet and nutty, this banana sundae features our creamy butterscotch ice cream with caramelized powdered nuts, bananas, and a drizzle of honey.",
                                                                    "imageId": "xyzo6bnmzc1aspobpmbo",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 15400,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.3",
                                                                            "ratingCount": "8 ratings",
                                                                            "ratingCountV2": "8"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822550",
                                                                    "name": "Arabian Dry Fruit Sundae",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Enjoy this royal treat of sundae made from combination of chocolate, butterscotch and fig ice cream. it's topped with chocolate sauce, cereals and dry fruits.",
                                                                    "imageId": "ruf8nsri8m5igsex3yvv",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 17600,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.5",
                                                                            "ratingCount": "7 ratings",
                                                                            "ratingCountV2": "7"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822607",
                                                                    "name": "Fruit Salad With Vanilla Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | You\u2019ll love this Fruit Salad with Ice Cream! It is made with freshly cut tropical fruits that are then mixed with pure honey. To finish it off, we top it with a scoop of rich vanilla and strawberry ice cream. This sweet treat is the perfect way to complete your meal.",
                                                                    "imageId": "jgrrpdkpqkg89mhzz9cy",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 12100,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.1",
                                                                            "ratingCount": "47 ratings",
                                                                            "ratingCountV2": "47"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519396",
                                                                    "name": "Gudbud",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | A refreshing combination scoops of Vanilla, Strawberry and Mango Ice Creams. With every bite you will experience the flavor adventures of fresh fruit salad and dry fruits. Because our Gudbud isn't just a treat, it's an experience.",
                                                                    "imageId": "awmh6lks9jjpdtdxcqfj",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 14300,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.9",
                                                                            "ratingCount": "18 ratings",
                                                                            "ratingCountV2": "18"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Empire Special Thick Shakes",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519287",
                                                                    "name": "Fig (Anjeer)Thick Shakes",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Boasting a delightfully creamy and luxurious texture, our Anjeer Thick shake is a treat for all your senses. You'll love the distinctive flavour of figs, ice cold milk, chocolate sauce, and velvety ice cream.",
                                                                    "imageId": "qlwu3dhy80nvz5ny4nhr",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685340",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452913",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452914",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685340",
                                                                                        "variationId": "71452913"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685340",
                                                                                        "variationId": "71452914"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.8",
                                                                            "ratingCount": "13 ratings",
                                                                            "ratingCountV2": "13"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519297",
                                                                    "name": "Chocolate Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Made with rich chocolate flavour ice cream and syrup, and blended with chilled milk and crushed ice cubes, this thick shake is a choco-lover\u2019s dream.",
                                                                    "imageId": "pf4dqma3zk99y0qbmkcf",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685342",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 88,
                                                                                        "default": 1,
                                                                                        "id": "71452917",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 255,
                                                                                        "id": "71452918",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685342",
                                                                                        "variationId": "71452917"
                                                                                    }
                                                                                ],
                                                                                "price": 8800
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685342",
                                                                                        "variationId": "71452918"
                                                                                    }
                                                                                ],
                                                                                "price": 25500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 8800,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.7",
                                                                            "ratingCount": "23 ratings",
                                                                            "ratingCountV2": "23"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "96906011",
                                                                    "name": "Avocado Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "pxyhxnyqzsqrfrddomo6",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 13500,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.7",
                                                                            "ratingCount": "14 ratings",
                                                                            "ratingCountV2": "14"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "103547845",
                                                                    "name": "Strawberry Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "c9cczsfbshesboawhpxa",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685014",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 88,
                                                                                        "default": 1,
                                                                                        "id": "71452257",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 255,
                                                                                        "id": "71452259",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685014",
                                                                                        "variationId": "71452257"
                                                                                    }
                                                                                ],
                                                                                "price": 8800
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685014",
                                                                                        "variationId": "71452259"
                                                                                    }
                                                                                ],
                                                                                "price": 25500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 8800,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "5.0",
                                                                            "ratingCount": "6 ratings",
                                                                            "ratingCountV2": "6"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "103547846",
                                                                    "name": "Vanilla Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "ga66rsafo2nekfbppjam",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685016",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 88,
                                                                                        "default": 1,
                                                                                        "id": "71452262",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 255,
                                                                                        "id": "71452263",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685016",
                                                                                        "variationId": "71452262"
                                                                                    }
                                                                                ],
                                                                                "price": 8800
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685016",
                                                                                        "variationId": "71452263"
                                                                                    }
                                                                                ],
                                                                                "price": 25500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 8800,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.2",
                                                                            "ratingCount": "4 ratings",
                                                                            "ratingCountV2": "4"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215259",
                                                                    "name": "Arabian Dry Fruit",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Our Arabian Dry Fruit Thick Shake is bursting with flavors. The smooth shake combines ice cream, mango pulp and crunchy dry fruits to make a truly indulgent drink. It\u2019s topped off with chocolate syrup for the perfect combination of sweetness, fruitiness and creaminess.",
                                                                    "imageId": "ujizbqb5tumbx26gmjaj",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685263",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 165,
                                                                                        "default": 1,
                                                                                        "id": "71452757",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 485,
                                                                                        "id": "71452758",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685263",
                                                                                        "variationId": "71452757"
                                                                                    }
                                                                                ],
                                                                                "price": 16500
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685263",
                                                                                        "variationId": "71452758"
                                                                                    }
                                                                                ],
                                                                                "price": 48500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 16500,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.2",
                                                                            "ratingCount": "84 ratings",
                                                                            "ratingCountV2": "84"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215260",
                                                                    "name": "Red Velvet Queen",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Our Red Velvet Queen Shake is a blissful marriage of rich, creamy ice cream, chunks of red velvet sponge and chilled milk topped with strawberry syrup, this thick shake will get your taste buds tingling!",
                                                                    "imageId": "gzwmxysqktbtir27y7tl",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685082",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 126.5,
                                                                                        "default": 1,
                                                                                        "id": "71452394",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 370.5,
                                                                                        "id": "71452395",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685082",
                                                                                        "variationId": "71452394"
                                                                                    }
                                                                                ],
                                                                                "price": 12650
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685082",
                                                                                        "variationId": "71452395"
                                                                                    }
                                                                                ],
                                                                                "price": 37050
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 12650,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "2.8",
                                                                            "ratingCount": "7 ratings",
                                                                            "ratingCountV2": "7"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215296",
                                                                    "name": "Apple Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Sweet, simple, and seriously good. Fresh apple slices are blended with ice cream and crushed ice cubes before being topped with a drizzle of the 100% pure honey.",
                                                                    "imageId": "mdbasvaq4y6enw7667wa",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685221",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452672",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452673",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685221",
                                                                                        "variationId": "71452672"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685221",
                                                                                        "variationId": "71452673"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.4",
                                                                            "ratingCount": "45 ratings",
                                                                            "ratingCountV2": "45"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215298",
                                                                    "name": "Dates Thick Shakes",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Lean back and enjoy the thick goodness of Dates Thick Shake which is blended to perfection using creamy ice cream and chilled milk.",
                                                                    "imageId": "zjbrmgzznqzprv0eqxkf",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685091",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452412",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452413",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685091",
                                                                                        "variationId": "71452412"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685091",
                                                                                        "variationId": "71452413"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.5",
                                                                            "ratingCount": "31 ratings",
                                                                            "ratingCountV2": "31"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215301",
                                                                    "name": "Mango Thick Shakes",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Relish the rich and luscious mango flavour with the delightful taste of ice cream blended with chilled milk and mango pulp.",
                                                                    "imageId": "vcatjomn6wq2f7uc5bif",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685327",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 88,
                                                                                        "default": 1,
                                                                                        "id": "71452886",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 255,
                                                                                        "id": "71452887",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685327",
                                                                                        "variationId": "71452886"
                                                                                    }
                                                                                ],
                                                                                "price": 8800
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685327",
                                                                                        "variationId": "71452887"
                                                                                    }
                                                                                ],
                                                                                "price": 25500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 8800,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.3",
                                                                            "ratingCount": "163 ratings",
                                                                            "ratingCountV2": "163"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215304",
                                                                    "name": "Sharjah Thick Shakes",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Constituted by the best of three - banana, mocha and chocolate syrup - this thick shake will keep you refreshed all day long.",
                                                                    "imageId": "qutjx0rbupksxw5m5txz",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685329",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452890",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452891",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685329",
                                                                                        "variationId": "71452890"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685329",
                                                                                        "variationId": "71452891"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.1",
                                                                            "ratingCount": "66 ratings",
                                                                            "ratingCountV2": "66"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519376",
                                                                    "name": "Chocolate Splash",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Delicious, lush and satisfying Chocolate Splash is our specialty thick shake that is blended with rich creamy ice cream, chunks of chocolate cake sponge with cold milk, crushed ice cubes and topped off with chocolate syrup.",
                                                                    "imageId": "yy7rt105kynal6krzj8u",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685346",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 121,
                                                                                        "default": 1,
                                                                                        "id": "71452925",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 355,
                                                                                        "id": "71452926",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685346",
                                                                                        "variationId": "71452925"
                                                                                    }
                                                                                ],
                                                                                "price": 12100
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685346",
                                                                                        "variationId": "71452926"
                                                                                    }
                                                                                ],
                                                                                "price": 35500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 12100,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519382",
                                                                    "name": "Kit Kat Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Treat yourself to this rich, thick Kit Kat chocolate shake at Empire Juice Shop. Made with chilled milk and ice cream mixed with crushed Kit Kat and chocolate syrup, you really can't beat this combination!",
                                                                    "imageId": "sl00qfxotvsasoajelyg",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685347",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 137.5,
                                                                                        "default": 1,
                                                                                        "id": "71452927",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 399.5,
                                                                                        "id": "71452928",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685347",
                                                                                        "variationId": "71452927"
                                                                                    }
                                                                                ],
                                                                                "price": 13750
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685347",
                                                                                        "variationId": "71452928"
                                                                                    }
                                                                                ],
                                                                                "price": 39950
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 13750,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519390",
                                                                    "name": "Oreo Thick Shake",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Oreo lovers know the deal. Made with chunks of Oreo Biscuits and a layer of rich, creamy ice cream that is topped off with chocolate syrup, this treat is loved by all.",
                                                                    "imageId": "s7we1y34hpfywovxabhy",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685348",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 137.5,
                                                                                        "default": 1,
                                                                                        "id": "71452929",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 398.5,
                                                                                        "id": "71452930",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685348",
                                                                                        "variationId": "71452929"
                                                                                    }
                                                                                ],
                                                                                "price": 13750
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685348",
                                                                                        "variationId": "71452930"
                                                                                    }
                                                                                ],
                                                                                "price": 39850
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 13750,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.3",
                                                                            "ratingCount": "3 ratings",
                                                                            "ratingCountV2": "3"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Cold Press Fresh Juices",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822534",
                                                                    "name": "Musambi Juice",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                                                    "imageId": "omk7dilfhvfqcaekxj7q",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685156",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 88,
                                                                                        "default": 1,
                                                                                        "id": "71452542",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 255,
                                                                                        "id": "71452543",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685156",
                                                                                        "variationId": "71452542"
                                                                                    }
                                                                                ],
                                                                                "price": 8800
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685156",
                                                                                        "variationId": "71452543"
                                                                                    }
                                                                                ],
                                                                                "price": 25500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 8800,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.7",
                                                                            "ratingCount": "131 ratings",
                                                                            "ratingCountV2": "131"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822540",
                                                                    "name": "Watermelon Juice",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                                                    "imageId": "fvckyewcu6jqz8zzn1ft",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685158",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 77,
                                                                                        "default": 1,
                                                                                        "id": "71452546",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 211,
                                                                                        "id": "71452547",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685158",
                                                                                        "variationId": "71452546"
                                                                                    }
                                                                                ],
                                                                                "price": 7700
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685158",
                                                                                        "variationId": "71452547"
                                                                                    }
                                                                                ],
                                                                                "price": 21100
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 7700,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.6",
                                                                            "ratingCount": "252 ratings",
                                                                            "ratingCountV2": "252"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822640",
                                                                    "name": "Lime Juice",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                                                    "imageId": "udoijcwgskygmkhlmtvi",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685262",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 55,
                                                                                        "default": 1,
                                                                                        "id": "71452755",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 155,
                                                                                        "id": "71452756",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685262",
                                                                                        "variationId": "71452755"
                                                                                    }
                                                                                ],
                                                                                "price": 5500
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685262",
                                                                                        "variationId": "71452756"
                                                                                    }
                                                                                ],
                                                                                "price": 15500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 5500,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.4",
                                                                            "ratingCount": "127 ratings",
                                                                            "ratingCountV2": "127"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519251",
                                                                    "name": "Pulpy Grape juice",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | 100% Pure Fresh Juices, No Water Added",
                                                                    "imageId": "olvadzot3td2gpamufru",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685339",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452911",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 267,
                                                                                        "id": "71452912",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685339",
                                                                                        "variationId": "71452911"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685339",
                                                                                        "variationId": "71452912"
                                                                                    }
                                                                                ],
                                                                                "price": 26700
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.4",
                                                                            "ratingCount": "54 ratings",
                                                                            "ratingCountV2": "54"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Mojitos & Coolers",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519344",
                                                                    "name": "Green Apple Mojito",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Our Green Apple Mojito is a comforting drink made from muddling fresh lime and fresh mint leaves combined with green apple syrup and chilled soda pour over crushed ice cubes.",
                                                                    "imageId": "ompoano0xaald9fikep5",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685345",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452923",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452924",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685345",
                                                                                        "variationId": "71452923"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685345",
                                                                                        "variationId": "71452924"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.8",
                                                                            "ratingCount": "6 ratings",
                                                                            "ratingCountV2": "6"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215289",
                                                                    "name": "Lime Soda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | A refreshing citrus flavored soda made with fresh lime, cooled with chilled soda and mixed with a touch of sugar syrup.",
                                                                    "imageId": "udoijcwgskygmkhlmtvi",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685013",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 66,
                                                                                        "default": 1,
                                                                                        "id": "71452255",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1ltr",
                                                                                        "price": 202,
                                                                                        "id": "71452256",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685013",
                                                                                        "variationId": "71452255"
                                                                                    }
                                                                                ],
                                                                                "price": 6600
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685013",
                                                                                        "variationId": "71452256"
                                                                                    }
                                                                                ],
                                                                                "price": 20200
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 6600,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.9",
                                                                            "ratingCount": "485 ratings",
                                                                            "ratingCountV2": "485"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "215291",
                                                                    "name": "Ginger Lime Soda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Ginger-lime soda is infused with the flavour of real ginger and lime, and sweetened sugar syrup.",
                                                                    "imageId": "hs1ym1gdojov0hqd3x5o",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685216",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 71.5,
                                                                                        "default": 1,
                                                                                        "id": "71452662",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 205,
                                                                                        "id": "71452663",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685216",
                                                                                        "variationId": "71452662"
                                                                                    }
                                                                                ],
                                                                                "price": 7150
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685216",
                                                                                        "variationId": "71452663"
                                                                                    }
                                                                                ],
                                                                                "price": 20500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 7150,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.7",
                                                                            "ratingCount": "122 ratings",
                                                                            "ratingCountV2": "122"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309058",
                                                                    "name": "Blue Angel",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Sip on a bright Blue Angel, a fun drink made with lime juice, sugar syrup, ice slush, soda and Blue Curacao syrup",
                                                                    "imageId": "pr3ptnuz1yfiy0lsxg32",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685217",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452664",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452665",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685217",
                                                                                        "variationId": "71452664"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685217",
                                                                                        "variationId": "71452665"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.4",
                                                                            "ratingCount": "31 ratings",
                                                                            "ratingCountV2": "31"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822488",
                                                                    "name": "Blue Lime Soda",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | Lighten up your mood with our Blue lime Soda. Made with blue curac?ao syrup, lemonade and splash of chilled soda water.",
                                                                    "imageId": "rkz3pwnxd3b3l7satpsa",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 8800,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.0",
                                                                            "ratingCount": "40 ratings",
                                                                            "ratingCountV2": "40"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822542",
                                                                    "name": "Lime Mint Cooler",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | This is a cool and refreshing blend of crushed ice cubes, lime juice, mint leaves, and chilled water that is blended together .",
                                                                    "imageId": "evunfe79jfwckwn2zx2r",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685167",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 71.5,
                                                                                        "default": 1,
                                                                                        "id": "71452564",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 205.5,
                                                                                        "id": "71452565",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685167",
                                                                                        "variationId": "71452564"
                                                                                    }
                                                                                ],
                                                                                "price": 7150
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685167",
                                                                                        "variationId": "71452565"
                                                                                    }
                                                                                ],
                                                                                "price": 20550
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 7150,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.7",
                                                                            "ratingCount": "34 ratings",
                                                                            "ratingCountV2": "34"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822626",
                                                                    "name": "Mojito Mint",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1 | A refreshing classical drink made with muddling lemon wedge and fresh mint leaves and combined with fresh lime juice, chilled soda and crushed ice",
                                                                    "imageId": "ye7vp7dueayhccb55znv",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21685219",
                                                                                "name": "Potion",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "300ml",
                                                                                        "price": 99,
                                                                                        "default": 1,
                                                                                        "id": "71452668",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "1Ltr",
                                                                                        "price": 290,
                                                                                        "id": "71452669",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685219",
                                                                                        "variationId": "71452668"
                                                                                    }
                                                                                ],
                                                                                "price": 9900
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21685219",
                                                                                        "variationId": "71452669"
                                                                                    }
                                                                                ],
                                                                                "price": 29000
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "defaultPrice": 9900,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.5",
                                                                            "ratingCount": "39 ratings",
                                                                            "ratingCountV2": "39"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822672",
                                                                    "name": "Lassi Sweet",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "tnh0qj18zqdtpx5neqvc",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 7700,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.4",
                                                                            "ratingCount": "41 ratings",
                                                                            "ratingCountV2": "41"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Kulfis",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309278",
                                                                    "name": "Badam Kulfi",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "zndmhkekkyowt6bbrzjy",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 7000,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.6",
                                                                            "ratingCount": "17 ratings",
                                                                            "ratingCountV2": "17"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309296",
                                                                    "name": "Pista Kulfi",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "rngynunellqmkinhe2t4",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 7000,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.7",
                                                                            "ratingCount": "27 ratings",
                                                                            "ratingCountV2": "27"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "100217612",
                                                                    "name": "Matka Kulfi",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "knpo2manobuiagemdkib",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 8900,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "4.6",
                                                                            "ratingCount": "13 ratings",
                                                                            "ratingCountV2": "13"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "101418733",
                                                                    "name": "Black Current Kulfi",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "u5xlpe6jfhjuknzqjlps",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 7000,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "5.0",
                                                                            "ratingCount": "6 ratings",
                                                                            "ratingCountV2": "6"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "101418735",
                                                                    "name": "Dry Fruits Kulfi",
                                                                    "category": "Juice Shop",
                                                                    "description": "Serves 1",
                                                                    "imageId": "leumcfclqrcwoyregzzy",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "price": 7000,
                                                                    "variants": {},
                                                                    "variantsV2": {},
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG",
                                                                        "portionSize": "Serves 1"
                                                                    },
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "5.0",
                                                                            "ratingCount": "3 ratings",
                                                                            "ratingCountV2": "3"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "title": "Scoop Ice Creams",
                                                    "itemCards": [
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309135",
                                                                    "name": "Pista Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21698387",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "71481571",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "71481572",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698387",
                                                                                        "variationId": "71481571"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698387",
                                                                                        "variationId": "71481572"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519265",
                                                                    "name": "Fig & Honey",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21698388",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "71481573",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "71481574",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698388",
                                                                                        "variationId": "71481573"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698388",
                                                                                        "variationId": "71481574"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519267",
                                                                    "name": "Butterscotch Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21698389",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "71481575",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "71481576",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698389",
                                                                                        "variationId": "71481575"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698389",
                                                                                        "variationId": "71481576"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.0",
                                                                            "ratingCount": "11 ratings",
                                                                            "ratingCountV2": "11"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "86519270",
                                                                    "name": "Black Currant Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "21698390",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "71481577",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "71481578",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698390",
                                                                                        "variationId": "71481577"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "21698390",
                                                                                        "variationId": "71481578"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {}
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "28309026",
                                                                    "name": "Strawberry Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "6952726",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "23380925",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "23380926",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "6952726",
                                                                                        "variationId": "23380925"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "6952726",
                                                                                        "variationId": "23380926"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.4",
                                                                            "ratingCount": "34 ratings",
                                                                            "ratingCountV2": "34"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822494",
                                                                    "name": "Chocolate Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "6952699",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "23378257",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "23378258",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "6952699",
                                                                                        "variationId": "23378257"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "6952699",
                                                                                        "variationId": "23378258"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.3",
                                                                            "ratingCount": "44 ratings",
                                                                            "ratingCountV2": "44"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        },
                                                        {
                                                            "card": {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                "info": {
                                                                    "id": "47822606",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "category": "Juice Shop",
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "variants": {},
                                                                    "variantsV2": {
                                                                        "variantGroups": [
                                                                            {
                                                                                "groupId": "6952722",
                                                                                "name": "Scoops",
                                                                                "variations": [
                                                                                    {
                                                                                        "name": "Single",
                                                                                        "price": 70,
                                                                                        "default": 1,
                                                                                        "id": "23380101",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    },
                                                                                    {
                                                                                        "name": "Double",
                                                                                        "price": 135,
                                                                                        "id": "23380102",
                                                                                        "inStock": 1,
                                                                                        "isVeg": 1,
                                                                                        "isEnabled": 1
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "pricingModels": [
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "6952722",
                                                                                        "variationId": "23380101"
                                                                                    }
                                                                                ],
                                                                                "price": 7000
                                                                            },
                                                                            {
                                                                                "variations": [
                                                                                    {
                                                                                        "groupId": "6952722",
                                                                                        "variationId": "23380102"
                                                                                    }
                                                                                ],
                                                                                "price": 13500
                                                                            }
                                                                        ]
                                                                    },
                                                                    "itemAttribute": {
                                                                        "vegClassifier": "VEG"
                                                                    },
                                                                    "defaultPrice": 7000,
                                                                    "ribbon": {},
                                                                    "type": "ITEM",
                                                                    "itemBadge": {},
                                                                    "badgesV2": {},
                                                                    "ratings": {
                                                                        "aggregatedRating": {
                                                                            "rating": "3.7",
                                                                            "ratingCount": "49 ratings",
                                                                            "ratingCountV2": "49"
                                                                        }
                                                                    }
                                                                },
                                                                "analytics": {},
                                                                "hideRestaurantDetails": true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Dosa And Appams",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215201",
                                                            "name": "Egg Dosa Chicken",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "price": 15300,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67836004",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835999",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836012",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67836021",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "155 ratings",
                                                                    "ratingCountV2": "155"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215199",
                                                            "name": "Egg Dosa",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "price": 6000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67891785",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891786",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891784",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891787",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "161 ratings",
                                                                    "ratingCountV2": "161"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215200",
                                                            "name": "Dosa Chicken",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "price": 14300,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67891819",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891820",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891818",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67891821",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "450 ratings",
                                                                    "ratingCountV2": "450"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822489",
                                                            "name": "Onion Dosa Veg",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "isVeg": 1,
                                                            "price": 13900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835155",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835149",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835164",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835170",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822530",
                                                            "name": "Plain Dosa (single)",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "isVeg": 1,
                                                            "price": 3100,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67835892",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835885",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835896",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67835908",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.6",
                                                                    "ratingCount": "62 ratings",
                                                                    "ratingCountV2": "62"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "215202",
                                                            "name": "Onion Dosa Chicken",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "price": 15300,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67840512",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840506",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840532",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67840547",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.9",
                                                                    "ratingCount": "20 ratings",
                                                                    "ratingCountV2": "20"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "47822639",
                                                            "name": "Onion Dosa",
                                                            "category": "Dosa And Appams",
                                                            "description": "Serves 1",
                                                            "isVeg": 1,
                                                            "price": 3600,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "67839709",
                                                                    "groupName": "Starters",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156423",
                                                                            "name": "Paneer Chilly Dry",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156419",
                                                                            "name": "Empire spl Chicken Kebab (qtr)",
                                                                            "price": 10500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156422",
                                                                            "name": "Pepper Mutton Dry (Qtr)",
                                                                            "price": 17500,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156421",
                                                                            "name": "Murg Tikka (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156420",
                                                                            "name": "Chilly Chicken Boneless (qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156424",
                                                                            "name": "Gobi Manchurian (Qtr)",
                                                                            "price": 9500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839704",
                                                                    "groupName": "Dips",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156438",
                                                                            "name": "Mint Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156437",
                                                                            "name": "Grill Chutney 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156436",
                                                                            "name": "Mayonnaise 50Ml",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 3,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839726",
                                                                    "groupName": "Gravy",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156457",
                                                                            "name": "Butter Chicken Boneless (Qtr)",
                                                                            "price": 15000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156460",
                                                                            "name": "Mutton Varuval (Qtr)",
                                                                            "price": 17000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156459",
                                                                            "name": "Kadai Chicken (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156462",
                                                                            "name": "Kadai Veg",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156458",
                                                                            "name": "Pepper Chicken Masala (Qtr)",
                                                                            "price": 14000,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156461",
                                                                            "name": "Paneer Butter Masala (Qtr)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 6,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "67839737",
                                                                    "groupName": "Beverage / Fresh Juice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "54156429",
                                                                            "name": "Watermelon Juice",
                                                                            "price": 7700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156428",
                                                                            "name": "Pulpy Grape Juice",
                                                                            "price": 9000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156427",
                                                                            "name": "Lime Soda",
                                                                            "price": 6000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156426",
                                                                            "name": "Pepsi 750 ML",
                                                                            "price": 3800,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "54156425",
                                                                            "name": "Pepsi 250 ML",
                                                                            "price": 1900,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 5,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 5 pm, today",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG",
                                                                "portionSize": "Serves 1"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.2",
                                                                    "ratingCount": "73 ratings",
                                                                    "ratingCountV2": "73"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                            "type": "FSSAI",
                                            "imageId": "fssai_final_edss9i",
                                            "text": [
                                                "License No. 11219334001702"
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                            "name": "Hotel Empire",
                                            "area": "Koramangala",
                                            "completeAddress": "103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "firstOffsetRequest": true,
        "isQCLink": false
    },
    "tid": "4d6d0f2b-a65c-4e67-ba69-d14eee90d4ec",
    "sid": "8gpec29b-3d9e-47ce-aa35-b9951d9befd9",
    "deviceId": "73a27926-1d32-d93a-8a46-34268cac4f66",
    "csrfToken": "AFIrMeAEZHGG-BAEjPmApHNBZpoW8ab6Hlaf7HAE"
};
var $87607fab672c6ed3$export$2e2bcd8739ae039 = $87607fab672c6ed3$var$restaurantListData;


const $1d6384be0887e96b$export$7c02d0f492d1f24c = async ()=>{
    return 0, $87607fab672c6ed3$export$2e2bcd8739ae039;
};
const $1d6384be0887e96b$export$5037efc1945b5bfe = (resId)=>{
    return (0, $87607fab672c6ed3$export$2e2bcd8739ae039).find((restaurant)=>restaurant?.info?.id === resId) || null;
};
const $1d6384be0887e96b$export$ee06668de3c3ed7d = ()=>{
    return (0, $87607fab672c6ed3$export$6f49b4016bfc8d56)?.data?.cards?.[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards?.filter((card)=>card?.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory") || [];
};


const $4e5e7144d3dd8c29$export$97e3a2ea947db25d = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("restaurant/fetchRestaurants", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        return await (0, $1d6384be0887e96b$export$7c02d0f492d1f24c)();
    } catch (error) {
        return rejectWithValue("Unable to load restaurants right now.");
    }
}, {
    condition: (_, { getState: getState })=>{
        const { restaurant: restaurant } = getState();
        return restaurant.status !== "loading" && restaurant.list.length === 0;
    }
});
const $4e5e7144d3dd8c29$export$4b003a7221a59389 = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("restaurant/fetchRestaurantMenu", async (resId, { rejectWithValue: rejectWithValue })=>{
    try {
        const restaurant = (0, $1d6384be0887e96b$export$5037efc1945b5bfe)(resId);
        if (!restaurant) return rejectWithValue("Restaurant details were not found.");
        return {
            resId: resId,
            restaurant: restaurant,
            categories: (0, $1d6384be0887e96b$export$ee06668de3c3ed7d)()
        };
    } catch (error) {
        return rejectWithValue("Unable to load the restaurant menu right now.");
    }
}, {
    condition: (resId, { getState: getState })=>{
        const menuEntry = getState().restaurant.menuById[resId];
        // Avoid duplicate requests when a menu is already loading or has already
        // been cached for the selected restaurant.
        return !menuEntry || menuEntry.status !== "loading" && !menuEntry.loaded;
    }
});
const $4e5e7144d3dd8c29$var$initialState = {
    list: [],
    status: "idle",
    error: null,
    menuById: {}
};
const $4e5e7144d3dd8c29$var$restaurantSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "restaurant",
    initialState: $4e5e7144d3dd8c29$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4e5e7144d3dd8c29$export$97e3a2ea947db25d.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($4e5e7144d3dd8c29$export$97e3a2ea947db25d.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.list = action.payload;
        }).addCase($4e5e7144d3dd8c29$export$97e3a2ea947db25d.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload || "Unable to load restaurants.";
        }).addCase($4e5e7144d3dd8c29$export$4b003a7221a59389.pending, (state, action)=>{
            const resId = action.meta.arg;
            state.menuById[resId] = {
                ...state.menuById[resId],
                status: "loading",
                error: null,
                loaded: false
            };
        }).addCase($4e5e7144d3dd8c29$export$4b003a7221a59389.fulfilled, (state, action)=>{
            const { resId: resId, restaurant: restaurant, categories: categories } = action.payload;
            state.menuById[resId] = {
                status: "succeeded",
                error: null,
                loaded: true,
                restaurant: restaurant,
                categories: categories
            };
        }).addCase($4e5e7144d3dd8c29$export$4b003a7221a59389.rejected, (state, action)=>{
            const resId = action.meta.arg;
            state.menuById[resId] = {
                ...state.menuById[resId],
                status: "failed",
                error: action.payload || "Unable to load menu.",
                loaded: false
            };
        });
    }
});
var $4e5e7144d3dd8c29$export$2e2bcd8739ae039 = $4e5e7144d3dd8c29$var$restaurantSlice.reducer;


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}


var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;



var $acw62 = parcelRequire("acw62");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $44fd68b3b250de87$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $44fd68b3b250de87$var$now = $44fd68b3b250de87$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $44fd68b3b250de87$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $44fd68b3b250de87$var$requestTimeout(callback, delay) {
    var start = $44fd68b3b250de87$var$now();
    function tick() {
        if ($44fd68b3b250de87$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $44fd68b3b250de87$var$size = -1; // This utility copied from "dom-helpers" package.
function $44fd68b3b250de87$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($44fd68b3b250de87$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $44fd68b3b250de87$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $44fd68b3b250de87$var$size;
}
var $44fd68b3b250de87$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $44fd68b3b250de87$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($44fd68b3b250de87$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $44fd68b3b250de87$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $44fd68b3b250de87$var$cachedRTLResult = 'negative';
            else $44fd68b3b250de87$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $44fd68b3b250de87$var$cachedRTLResult;
    }
    return $44fd68b3b250de87$var$cachedRTLResult;
}
var $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $44fd68b3b250de87$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $44fd68b3b250de87$var$devWarningsOverscanCount = null;
var $44fd68b3b250de87$var$devWarningsOverscanRowsColumnsCount = null;
var $44fd68b3b250de87$var$devWarningsTagName = null;
function $44fd68b3b250de87$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($44fd68b3b250de87$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $44fd68b3b250de87$var$requestTimeout(_this._resetIsScrolling, $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $44fd68b3b250de87$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $44fd68b3b250de87$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($44fd68b3b250de87$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $44fd68b3b250de87$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $acw62.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $acw62.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $acw62.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $acw62.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $44fd68b3b250de87$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $44fd68b3b250de87$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $44fd68b3b250de87$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $44fd68b3b250de87$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $44fd68b3b250de87$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $44fd68b3b250de87$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $44fd68b3b250de87$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $44fd68b3b250de87$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $44fd68b3b250de87$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $44fd68b3b250de87$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $44fd68b3b250de87$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $44fd68b3b250de87$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $44fd68b3b250de87$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $44fd68b3b250de87$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $44fd68b3b250de87$var$getEstimatedTotalWidth(props, instanceProps) : $44fd68b3b250de87$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $44fd68b3b250de87$export$32c206c84102e73c = /*#__PURE__*/ $44fd68b3b250de87$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $44fd68b3b250de87$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $44fd68b3b250de87$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $44fd68b3b250de87$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $44fd68b3b250de87$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $44fd68b3b250de87$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $44fd68b3b250de87$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $44fd68b3b250de87$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $44fd68b3b250de87$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $44fd68b3b250de87$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $44fd68b3b250de87$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $44fd68b3b250de87$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $44fd68b3b250de87$var$devWarningsDirection = null;
var $44fd68b3b250de87$var$devWarningsTagName$1 = null;
function $44fd68b3b250de87$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($44fd68b3b250de87$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $44fd68b3b250de87$var$requestTimeout(_this._resetIsScrolling, $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $44fd68b3b250de87$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $44fd68b3b250de87$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $44fd68b3b250de87$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($44fd68b3b250de87$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $44fd68b3b250de87$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $acw62.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $acw62.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $acw62.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $acw62.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $44fd68b3b250de87$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $44fd68b3b250de87$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $44fd68b3b250de87$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $44fd68b3b250de87$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $44fd68b3b250de87$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $44fd68b3b250de87$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $44fd68b3b250de87$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $44fd68b3b250de87$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $44fd68b3b250de87$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $44fd68b3b250de87$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $44fd68b3b250de87$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $44fd68b3b250de87$export$d8ac3b6b20be856e = /*#__PURE__*/ $44fd68b3b250de87$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $44fd68b3b250de87$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $44fd68b3b250de87$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $44fd68b3b250de87$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $44fd68b3b250de87$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $44fd68b3b250de87$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $44fd68b3b250de87$export$f331158cccad7361 = /*#__PURE__*/ $44fd68b3b250de87$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $44fd68b3b250de87$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $44fd68b3b250de87$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $44fd68b3b250de87$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $44fd68b3b250de87$var$_excluded = [
    "style"
], $44fd68b3b250de87$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $44fd68b3b250de87$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(prevProps, $44fd68b3b250de87$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(nextProps, $44fd68b3b250de87$var$_excluded2);
    return !$44fd68b3b250de87$var$shallowDiffers(prevStyle, nextStyle) && !$44fd68b3b250de87$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $44fd68b3b250de87$export$aa365c903ed149ff(nextProps, nextState) {
    return !$44fd68b3b250de87$export$b141efd0b0fb9174(this.props, nextProps) || $44fd68b3b250de87$var$shallowDiffers(this.state, nextState);
}



var $ayMG0 = parcelRequire("ayMG0");
const $0f51076aadfdab64$export$a2cb54b9b29b68f8 = ({ count: count = 8 })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "skeleton-grid",
        "aria-hidden": "true",
        children: Array.from({
            length: count
        }).map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "skeleton-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "skeleton-block skeleton-image"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "skeleton-block skeleton-title"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "skeleton-block skeleton-meta"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "skeleton-block skeleton-meta short"
                    })
                ]
            }, `restaurant-skeleton-${index}`))
    });
};
const $0f51076aadfdab64$export$34f241935f75ea50 = ({ count: count = 4 })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "menu-skeleton",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "skeleton-block skeleton-menu-heading"
            }),
            Array.from({
                length: count
            }).map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "skeleton-category",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "skeleton-block skeleton-category-title"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "skeleton-block skeleton-category-subtitle"
                        })
                    ]
                }, `menu-skeleton-${index}`))
        ]
    });
};



var $gxbk0 = parcelRequire("gxbk0");

var $ayMG0 = parcelRequire("ayMG0");

const $f6beefcb5e114325$var$EmptyState = ({ title: title, description: description, actionLabel: actionLabel, actionTo: actionTo = "/" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "empty-state",
        role: "status",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "empty-state-icon",
                children: "\uD83C\uDF7D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: description
            }),
            actionLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "primary-action action-link",
                to: actionTo,
                children: actionLabel
            }) : null
        ]
    });
};
var $f6beefcb5e114325$export$2e2bcd8739ae039 = $f6beefcb5e114325$var$EmptyState;


const $88d2c9e81e05d815$var$GRID_GAP = 30;
const $88d2c9e81e05d815$var$DESKTOP_MAX_WIDTH = 1400;
const $88d2c9e81e05d815$var$MOBILE_BREAKPOINT = 768;
const $88d2c9e81e05d815$var$TABLET_BREAKPOINT = 1200;
const $88d2c9e81e05d815$var$ROW_HEIGHT = 350;
const $88d2c9e81e05d815$var$getViewportWidth = ()=>{
    if (typeof window === "undefined") return $88d2c9e81e05d815$var$DESKTOP_MAX_WIDTH;
    return window.innerWidth;
};
const $88d2c9e81e05d815$var$RestaurantGridCell = /*#__PURE__*/ (0, $acw62.memo)(({ columnIndex: columnIndex, rowIndex: rowIndex, style: style, data: data })=>{
    const { restaurants: restaurants, columnCount: columnCount } = data;
    const restaurantIndex = rowIndex * columnCount + columnIndex;
    const res = restaurants[restaurantIndex];
    if (!res) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            ...style,
            // react-window gives each cell fixed coordinates; we trim and offset
            // those bounds a bit so the cards render with visible gaps.
            left: style.left + $88d2c9e81e05d815$var$GRID_GAP / 2,
            top: style.top + $88d2c9e81e05d815$var$GRID_GAP / 2,
            width: style.width - $88d2c9e81e05d815$var$GRID_GAP,
            height: style.height - $88d2c9e81e05d815$var$GRID_GAP
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
            to: "/restaurants/" + res.info.id,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd74848ad11950cb$export$2e2bcd8739ae039), {
                resName: res?.info.name,
                cuisines: res?.info.cuisines.join(", "),
                time: res?.info.sla.deliveryTime,
                rating: res?.info.avgRating,
                image: res?.info.cloudinaryImageId
            })
        }, res.info.id)
    });
});
const $88d2c9e81e05d815$var$Body = ()=>{
    // useState is a react hook or state variable which has the power of keeping the data layer in sync with the ui layer
    // dont create state var in conditions/ functions -> if, for, 
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const [viewportWidth, setViewportWidth] = (0, $acw62.useState)($88d2c9e81e05d815$var$getViewportWidth);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { list: listOfRes, status: status, error: error } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.restaurant);
    //it takes callback and dependency list as arg
    // called everytime comp render if no dep arr
    // if [], called once on the initial render
    // if [listOfRes], called everytime when listOfRes changes
    (0, $acw62.useEffect)(()=>{
        // const resData = await fetch(
        //   "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.40980&lng=77.31000&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"
        // );
        dispatch((0, $4e5e7144d3dd8c29$export$97e3a2ea947db25d)());
        // called when unmounting the component
        return ()=>{};
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            setViewportWidth($88d2c9e81e05d815$var$getViewportWidth());
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const onlineStatus = (0, $caae5368ead5995e$export$2e2bcd8739ae039)();
    if (onlineStatus === false) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6beefcb5e114325$export$2e2bcd8739ae039), {
        title: "You are offline right now",
        description: "Reconnect to the internet to browse nearby restaurants and live menu details."
    });
    const { loggedInUser: loggedInUser, setUserName: setUserName } = (0, $acw62.useContext)((0, $gxbk0.default));
    const handleSearchChange = (0, $acw62.useCallback)((e)=>{
        setSearchText(e.target.value);
    }, []);
    const handleRetryRestaurants = (0, $acw62.useCallback)(()=>{
        dispatch((0, $4e5e7144d3dd8c29$export$97e3a2ea947db25d)());
    }, [
        dispatch
    ]);
    const handleClearSearch = (0, $acw62.useCallback)(()=>{
        setSearchText("");
    }, []);
    const filteredRestaurants = (0, $acw62.useMemo)(()=>{
        // Keep search filtering memoized because the virtualized grid re-renders
        // frequently and we only want to recompute when inputs actually change.
        const normalizedSearchText = searchText.trim().toLowerCase();
        if (!normalizedSearchText) return listOfRes;
        return listOfRes.filter((res)=>res?.info?.name?.toLowerCase().includes(normalizedSearchText));
    }, [
        listOfRes,
        searchText
    ]);
    const columnCount = (0, $acw62.useMemo)(()=>{
        if (viewportWidth <= $88d2c9e81e05d815$var$MOBILE_BREAKPOINT) return 1;
        if (viewportWidth <= $88d2c9e81e05d815$var$TABLET_BREAKPOINT) return 2;
        return 4;
    }, [
        viewportWidth
    ]);
    const gridWidth = (0, $acw62.useMemo)(()=>{
        const horizontalPadding = viewportWidth <= $88d2c9e81e05d815$var$MOBILE_BREAKPOINT ? 30 : 60;
        return Math.min($88d2c9e81e05d815$var$DESKTOP_MAX_WIDTH, viewportWidth - horizontalPadding);
    }, [
        viewportWidth
    ]);
    const columnWidth = (0, $acw62.useMemo)(()=>{
        return Math.floor(gridWidth / columnCount);
    }, [
        gridWidth,
        columnCount
    ]);
    const rowCount = (0, $acw62.useMemo)(()=>{
        return Math.ceil(filteredRestaurants.length / columnCount);
    }, [
        filteredRestaurants.length,
        columnCount
    ]);
    const gridHeight = (0, $acw62.useMemo)(()=>{
        const visibleRows = viewportWidth <= $88d2c9e81e05d815$var$MOBILE_BREAKPOINT ? 2 : 2;
        return Math.min(rowCount, visibleRows) * $88d2c9e81e05d815$var$ROW_HEIGHT;
    }, [
        rowCount,
        viewportWidth
    ]);
    const gridData = (0, $acw62.useMemo)(()=>{
        // react-window passes one shared itemData object into every cell render.
        return {
            restaurants: filteredRestaurants,
            columnCount: columnCount
        };
    }, [
        filteredRestaurants,
        columnCount
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "search",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    className: "search-input",
                    placeholder: "Enter a restaurant",
                    value: searchText,
                    onChange: handleSearchChange
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "res-container",
                children: [
                    status === "loading" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f51076aadfdab64$export$a2cb54b9b29b68f8), {}),
                    status === "failed" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "inline-feedback error-feedback",
                        role: "alert",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: "We could not load restaurants."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: error || "Please try again in a moment."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "primary-action",
                                onClick: handleRetryRestaurants,
                                children: "Retry"
                            })
                        ]
                    }),
                    status === "succeeded" && filteredRestaurants.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "res-grid-shell",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44fd68b3b250de87$export$f331158cccad7361), {
                            className: "res-grid",
                            columnCount: columnCount,
                            columnWidth: columnWidth,
                            height: gridHeight,
                            rowCount: rowCount,
                            rowHeight: $88d2c9e81e05d815$var$ROW_HEIGHT,
                            width: gridWidth,
                            itemData: gridData,
                            children: $88d2c9e81e05d815$var$RestaurantGridCell
                        })
                    }),
                    status === "succeeded" && filteredRestaurants.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "empty-state",
                        role: "status",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "empty-state-icon",
                                children: "\uD83D\uDD0E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: "No restaurants matched your search"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    'We could not find anything for "',
                                    searchText,
                                    '". Try a shorter or different restaurant name.'
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "primary-action",
                                onClick: handleClearSearch,
                                children: "Clear search"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $88d2c9e81e05d815$export$2e2bcd8739ae039 = $88d2c9e81e05d815$var$Body;



var $ayMG0 = parcelRequire("ayMG0");

const $8f0cc534f6c9aa78$var$Error = ()=>{
    const err = (0, $7939e29d663dd3ed$export$ed527bf60f6e05f2)();
    const statusCode = err?.status || 500;
    const statusText = err?.statusText || "Unexpected Error";
    const message = err?.data?.message || err?.error?.message || "The page could not be loaded. Please try again from the home screen.";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "error-state-page",
        role: "alert",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "error-card",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "error-eyebrow",
                    children: "Route Error"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    children: "We could not open this page."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "error-copy",
                    children: message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "error-message",
                    children: [
                        statusCode,
                        " ",
                        statusText
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    className: "primary-action action-link",
                    to: "/",
                    children: "Back to home"
                })
            ]
        })
    });
};
var $8f0cc534f6c9aa78$export$2e2bcd8739ae039 = $8f0cc534f6c9aa78$var$Error;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $8e060705e4af3350$var$useRestaurantMenu = (resId)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const menuState = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.restaurant.menuById[resId]);
    (0, $acw62.useEffect)(()=>{
        if (resId) dispatch((0, $4e5e7144d3dd8c29$export$4b003a7221a59389)(resId));
    }, [
        dispatch,
        resId
    ]);
    const refetchMenu = ()=>{
        // Expose retry behavior from the hook so page components stay focused on UI.
        if (resId) dispatch((0, $4e5e7144d3dd8c29$export$4b003a7221a59389)(resId));
    };
    return {
        restaurant: menuState?.restaurant || null,
        categories: menuState?.categories || [],
        status: menuState?.status || "idle",
        error: menuState?.error || null,
        refetchMenu: refetchMenu
    };
};
var $8e060705e4af3350$export$2e2bcd8739ae039 = $8e060705e4af3350$var$useRestaurantMenu;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $137ab1bd6860c41d$export$b06e7e560792a2f3 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "veg-icon",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "16",
                    height: "16",
                    rx: "2",
                    fill: "none",
                    stroke: "#0f8a3c",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "9",
                    cy: "9",
                    r: "4",
                    fill: "#0f8a3c"
                })
            ]
        })
    });
const $137ab1bd6860c41d$export$202815e61e6409b6 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "non-veg-icon",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "16",
                    height: "16",
                    rx: "2",
                    fill: "none",
                    stroke: "#b11226",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "9",
                    cy: "9",
                    r: "4",
                    fill: "#b11226"
                })
            ]
        })
    });



const $33993338c35354bc$var$cartSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
            console.log(state.items);
        },
        removeItem: (state)=>{
            state.items.pop();
        },
        clearCart: (state)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $33993338c35354bc$export$fb9705de59d96855, removeItem: $33993338c35354bc$export$fe2d9b4e03920b4c, clearCart: $33993338c35354bc$export$810121176e3e3671 } = $33993338c35354bc$var$cartSlice.actions;
var $33993338c35354bc$export$2e2bcd8739ae039 = $33993338c35354bc$var$cartSlice.reducer;


const $0018c32649bb9e0f$var$ItemCard = ({ itemInfo: itemInfo })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const itemPrice = itemInfo.price ? itemInfo.price / 100 : itemInfo.defaultPrice / 100;
    const itemRating = itemInfo?.ratings?.aggregatedRating?.rating || "New";
    const handleAddItems = (0, $acw62.useCallback)(()=>{
        dispatch((0, $33993338c35354bc$export$fb9705de59d96855)(itemInfo));
    }, [
        dispatch,
        itemInfo
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "item-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "item-info",
                children: [
                    itemInfo.itemAttribute.vegClassifier === "NONVEG" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $137ab1bd6860c41d$export$202815e61e6409b6), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $137ab1bd6860c41d$export$b06e7e560792a2f3), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "item-name",
                        children: itemInfo.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "item-details",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "item-price",
                                children: [
                                    "$",
                                    itemPrice
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "item-rating",
                                children: [
                                    "Rating: ",
                                    itemRating
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "item-desc",
                                children: itemInfo?.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "item-image",
                        src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" + itemInfo.imageId
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "add-button",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: handleAddItems,
                            children: "ADD+"
                        })
                    })
                ]
            })
        ]
    });
};
var $0018c32649bb9e0f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($0018c32649bb9e0f$var$ItemCard);


const $558fd983ecc14451$var$RestaurantCategory = ({ data: data, showResItems: showResItems, onToggle: onToggle })=>{
    const itemCards = data?.itemCards || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "res-category",
        onClick: onToggle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "res-category-title",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                children: [
                                    data?.title,
                                    " (",
                                    itemCards.length,
                                    ") "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            " ",
                            "-->",
                            " "
                        ]
                    })
                ]
            }),
            showResItems && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "res-category-items",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    children: itemCards.map((itemCard)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0018c32649bb9e0f$export$2e2bcd8739ae039), {
                                itemInfo: itemCard?.card?.info
                            })
                        }, itemCard?.card?.info?.id);
                    })
                })
            })
        ]
    });
};
var $558fd983ecc14451$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($558fd983ecc14451$var$RestaurantCategory);





const $a329f120eb00e7c8$var$Menu = ()=>{
    const { resId: resId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { restaurant: restaurant, categories: categories, status: status, error: error, refetchMenu: refetchMenu } = (0, $8e060705e4af3350$export$2e2bcd8739ae039)(resId); // calling a custom hook
    const onlineStatus = (0, $caae5368ead5995e$export$2e2bcd8739ae039)();
    const [showIndex, setShowIndex] = (0, $acw62.useState)(null);
    const handleCategoryToggle = (0, $acw62.useCallback)((index)=>{
        setShowIndex((prevIndex)=>prevIndex === index ? null : index);
    }, []);
    if (onlineStatus === false) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "menu",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6beefcb5e114325$export$2e2bcd8739ae039), {
            title: "Menu unavailable while offline",
            description: "Reconnect to load restaurant items, pricing, and availability."
        })
    });
    if (status === "loading") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "menu",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f51076aadfdab64$export$34f241935f75ea50), {})
    });
    if (status === "failed") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "menu",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "inline-feedback error-feedback",
            role: "alert",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "We could not load this menu."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: error || "Please refresh this restaurant and try again."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "primary-action",
                    onClick: refetchMenu,
                    children: "Retry"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "menu",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "menu-heading",
                children: restaurant?.info?.name
            }),
            !categories?.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6beefcb5e114325$export$2e2bcd8739ae039), {
                title: "No menu sections available",
                description: "This restaurant does not have menu categories to show right now.",
                actionLabel: "Back to home",
                actionTo: "/"
            }),
            categories?.map((category, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $558fd983ecc14451$export$2e2bcd8739ae039), {
                    data: category?.card?.card,
                    showResItems: index === showIndex,
                    onToggle: ()=>handleCategoryToggle(index)
                }, category?.card?.card?.title);
            })
        ]
    });
};
var $a329f120eb00e7c8$export$2e2bcd8739ae039 = $a329f120eb00e7c8$var$Menu;



var $ayMG0 = parcelRequire("ayMG0");







var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
const $9ada8b03b89c1e31$var$CUISINE_KEYWORDS = {
    Chinese: [
        "noodle",
        "manchurian",
        "fried rice",
        "schezwan",
        "dimsum",
        "momo",
        "wok"
    ],
    Bakery: [
        "cake",
        "brownie",
        "pastry",
        "cookie",
        "muffin",
        "croissant"
    ],
    Desserts: [
        "dessert",
        "ice cream",
        "chocolate",
        "sweet",
        "shake",
        "cheesecake"
    ],
    Pizza: [
        "pizza",
        "margherita",
        "pepperoni"
    ],
    Burgers: [
        "burger",
        "fries",
        "wrap",
        "sandwich"
    ],
    Biryani: [
        "biryani",
        "kebab",
        "tandoori",
        "grill"
    ],
    Indian: [
        "paneer",
        "dal",
        "thali",
        "curry",
        "roti",
        "paratha"
    ]
};
const $9ada8b03b89c1e31$var$getCartText = (cartItems)=>{
    return cartItems.map((item)=>`${item?.name || ""} ${item?.description || ""}`.toLowerCase()).join(" ");
};
const $9ada8b03b89c1e31$var$getPreferenceScores = (cartItems)=>{
    const cartText = $9ada8b03b89c1e31$var$getCartText(cartItems);
    return Object.entries($9ada8b03b89c1e31$var$CUISINE_KEYWORDS).reduce((scores, [cuisine, keywords])=>{
        const score = keywords.reduce((total, keyword)=>{
            return cartText.includes(keyword) ? total + 1 : total;
        }, 0);
        if (score > 0) scores[cuisine] = score;
        return scores;
    }, {});
};
const $9ada8b03b89c1e31$export$7267f28fb8d68c59 = (cartItems, restaurants)=>{
    if (!cartItems.length || !restaurants.length) return [];
    const preferenceScores = $9ada8b03b89c1e31$var$getPreferenceScores(cartItems);
    const topCuisine = Object.entries(preferenceScores).sort((a, b)=>b[1] - a[1])[0]?.[0];
    // This is a lightweight "AI-style" ranking pass: infer cuisine intent from
    // cart text, then score restaurants by cuisine overlap and rating.
    const rankedRestaurants = restaurants.map((restaurant)=>{
        const cuisines = restaurant?.info?.cuisines || [];
        const matchedCuisine = cuisines.find((cuisine)=>preferenceScores[cuisine]);
        return {
            restaurant: restaurant,
            score: matchedCuisine ? preferenceScores[matchedCuisine] : 0,
            matchedCuisine: matchedCuisine
        };
    }).filter(({ score: score })=>score > 0).sort((a, b)=>b.score - a.score || b.restaurant?.info?.avgRating - a.restaurant?.info?.avgRating).slice(0, 3).map(({ restaurant: restaurant, matchedCuisine: matchedCuisine })=>({
            id: restaurant?.info?.id,
            name: restaurant?.info?.name,
            cuisines: restaurant?.info?.cuisines || [],
            rating: restaurant?.info?.avgRating,
            deliveryTime: restaurant?.info?.sla?.deliveryTime,
            matchedCuisine: matchedCuisine,
            reason: `Based on your cart, you seem to be in the mood for ${matchedCuisine}.`
        }));
    if (rankedRestaurants.length > 0) return rankedRestaurants;
    if (!topCuisine) return restaurants.slice(0, 3).map((restaurant)=>({
            id: restaurant?.info?.id,
            name: restaurant?.info?.name,
            cuisines: restaurant?.info?.cuisines || [],
            rating: restaurant?.info?.avgRating,
            deliveryTime: restaurant?.info?.sla?.deliveryTime,
            matchedCuisine: null,
            reason: "Popular nearby picks based on what customers often order together."
        }));
    return [];
};


const $313230d8e1321598$var$SmartRecommendations = ({ cartItems: cartItems, restaurants: restaurants })=>{
    const recommendations = (0, $acw62.useMemo)(()=>{
        return (0, $9ada8b03b89c1e31$export$7267f28fb8d68c59)(cartItems, restaurants);
    }, [
        cartItems,
        restaurants
    ]);
    if (!recommendations.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "smart-picks",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "smart-picks-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "smart-picks-eyebrow",
                        children: "AI-Powered Picks"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Recommended for your current cart"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "These suggestions are generated from the dish names and descriptions you have already added."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "smart-picks-grid",
                children: recommendations.map((restaurant)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "smart-pick-card",
                        to: `/restaurants/${restaurant.id}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "smart-pick-badge",
                                children: restaurant.matchedCuisine || "Popular"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: restaurant.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "smart-pick-meta",
                                children: restaurant.cuisines.join(", ")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "smart-pick-reason",
                                children: restaurant.reason
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "smart-pick-footer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            restaurant.rating,
                                            " rating"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            restaurant.deliveryTime,
                                            " mins"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, restaurant.id))
            })
        ]
    });
};
var $313230d8e1321598$export$2e2bcd8739ae039 = $313230d8e1321598$var$SmartRecommendations;



var $acw62 = parcelRequire("acw62");
const $2112538953213f72$var$Cart = ()=>{
    const cartItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.cart.items);
    const restaurantList = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.restaurant.list);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $33993338c35354bc$export$810121176e3e3671)());
    };
    (0, $acw62.useEffect)(()=>{
        if (cartItems.length > 0) dispatch((0, $4e5e7144d3dd8c29$export$97e3a2ea947db25d)());
    }, [
        cartItems.length,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "cart-page",
        children: [
            cartItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "clear-cart",
                onClick: handleClearCart,
                children: "Clear Cart"
            }),
            cartItems.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6beefcb5e114325$export$2e2bcd8739ae039), {
                title: "Your cart is feeling light",
                description: "Add a few dishes to place an order and see them listed here.",
                actionLabel: "Browse restaurants",
                actionTo: "/"
            }),
            cartItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "cart-list",
                children: [
                    cartItems.map((item, index)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0018c32649bb9e0f$export$2e2bcd8739ae039), {
                                itemInfo: item
                            })
                        }, item.id + "" + index);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "primary-action action-link cart-cta",
                        to: "/",
                        children: "Add more items"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $313230d8e1321598$export$2e2bcd8739ae039), {
                        cartItems: cartItems,
                        restaurants: restaurantList
                    })
                ]
            })
        ]
    });
};
var $2112538953213f72$export$2e2bcd8739ae039 = $2112538953213f72$var$Cart;



var $ayMG0 = parcelRequire("ayMG0");

const $8e4ea65ee2d9b6cc$var$ProtectedRoute = ({ children: children })=>{
    const isAuthenticated = true;
    if (!isAuthenticated) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    return children;
};
var $8e4ea65ee2d9b6cc$export$2e2bcd8739ae039 = $8e4ea65ee2d9b6cc$var$ProtectedRoute;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
class $bd1bfaf925948b54$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("Application crashed:", error, errorInfo);
    }
    handleRefresh = ()=>{
        window.location.assign("/");
    };
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "error-state-page",
            role: "alert",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "error-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "error-eyebrow",
                        children: "Application Error"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: "Something broke on our side."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "error-copy",
                        children: "We could not render this screen safely. Refresh and try again."
                    }),
                    this.state.error?.message ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "error-message",
                        children: this.state.error.message
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "primary-action",
                        onClick: this.handleRefresh,
                        children: "Go to home"
                    })
                ]
            })
        });
        return this.props.children;
    }
}
var $bd1bfaf925948b54$export$2e2bcd8739ae039 = $bd1bfaf925948b54$var$ErrorBoundary;




var $gxbk0 = parcelRequire("gxbk0");




const $8b9d6dc968d848e3$var$appStore = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $33993338c35354bc$export$2e2bcd8739ae039),
        restaurant: (0, $4e5e7144d3dd8c29$export$2e2bcd8739ae039)
    }
});
var $8b9d6dc968d848e3$export$2e2bcd8739ae039 = $8b9d6dc968d848e3$var$appStore;



// called dynamic import
const $ae3403f02907456e$var$About = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("a9zaE")));
const $ae3403f02907456e$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $acw62.useState)("Default");
    (0, $acw62.useEffect)(()=>{
        // this can come from some API
        const name = "Saloni";
        setUserName(name);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
            store: (0, $8b9d6dc968d848e3$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gxbk0.default).Provider, {
                value: {
                    loggedInUser: userName,
                    setUserName: setUserName
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3df07944bfa6aab3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
};
const $ae3403f02907456e$var$appRouter = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $ayMG0.jsx)($ae3403f02907456e$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f0cc534f6c9aa78$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e4ea65ee2d9b6cc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88d2c9e81e05d815$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                    fallback: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: "Loading..."
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($ae3403f02907456e$var$About, {})
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e4ea65ee2d9b6cc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2112538953213f72$export$2e2bcd8739ae039), {})
                })
            },
            {
                // this is dynamic routes
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a329f120eb00e7c8$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
const $ae3403f02907456e$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
// instead of this, using Router provider and providing config appRouter
// root.render(<AppLayout />);
$ae3403f02907456e$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd1bfaf925948b54$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
            router: $ae3403f02907456e$var$appRouter
        })
    })
}));


//# sourceMappingURL=repo.6de209e2.js.map
